/* eslint-disable import/prefer-default-export */
/* eslint-disable react/no-unknown-property */

import * as React from 'react';
import { SVGProps } from 'react';
import { SvgIcon } from '@mui/material';
import { SvgIconProps } from '@mui/material/SvgIcon/SvgIcon';

export const CalenderIcon = (props: SvgIconProps) => (
  <SvgIcon viewBox="0 0 16 16" {...props}>
    <g id="calendar">
      <path id="Vector" d="M0,0H16V16H0Z" fill="none" opacity="0" />
      <path id="Vector-2" data-name="Vector" d="M9.141,1.54V.5a.5.5,0,0,0-1,0v1H3.807V.5a.5.5,0,0,0-1,0V1.54A2.832,2.832,0,0,0,0,4.373a.335.335,0,0,0,.333.353h11.28a.331.331,0,0,0,.333-.353A2.832,2.832,0,0,0,9.141,1.54Z" transform="translate(2.026 0.833)" fill="currentColor" />
      <path id="Vector-3" data-name="Vector" d="M11.333,0H.667A.669.669,0,0,0,0,.667V4.773A2.99,2.99,0,0,0,3.333,8.107H8.667A2.99,2.99,0,0,0,12,4.773V.667A.669.669,0,0,0,11.333,0ZM4.14,5.58a1.05,1.05,0,0,1-.1.08.5.5,0,0,1-.12.06.424.424,0,0,1-.12.04.9.9,0,0,1-.133.013.664.664,0,0,1-.253-.053.688.688,0,0,1-.22-.14.676.676,0,0,1,0-.947.688.688,0,0,1,.22-.14.637.637,0,0,1,.387-.04.424.424,0,0,1,.12.04.5.5,0,0,1,.12.06l.1.08a.676.676,0,0,1,0,.947Zm0-2.333a.676.676,0,0,1-.947,0,.676.676,0,0,1,0-.947.666.666,0,0,1,.727-.14.622.622,0,0,1,.22.14.676.676,0,0,1,0,.947ZM6.473,5.58a.669.669,0,0,1-.947-.947.669.669,0,0,1,.947.947Zm0-2.333-.1.08a.5.5,0,0,1-.12.06.424.424,0,0,1-.12.04A.9.9,0,0,1,6,3.44a.66.66,0,0,1-.667-.667A.7.7,0,0,1,5.527,2.3a.622.622,0,0,1,.22-.14.666.666,0,0,1,.727.14.676.676,0,0,1,0,.947ZM8.807,5.58a.669.669,0,0,1-.947-.947.669.669,0,0,1,.947.947Zm0-2.333-.1.08a.5.5,0,0,1-.12.06.424.424,0,0,1-.12.04,1,1,0,0,1-.133.013.66.66,0,0,1-.667-.667A.7.7,0,0,1,7.86,2.3a.688.688,0,0,1,.22-.14.637.637,0,0,1,.387-.04.424.424,0,0,1,.12.04.5.5,0,0,1,.12.06l.1.08a.676.676,0,0,1,0,.947Z" transform="translate(2 6.56)" fill="currentColor" />
    </g>
  </SvgIcon>
);

export const PlayIcon = () => (
  <SvgIcon height="18px" width="18px" viewBox="0 0 18 18">
    <path
      id="Vector"
      d="M0,0H20V20H0Z"
      transform="translate(20 20) rotate(180)"
      fill="none"
      opacity="0"
    />
    <path
      id="Vector-2"
      data-name="Vector"
      d="M0,2.13V10.1a2.13,2.13,0,0,0,3.192,1.842L6.65,9.955l3.458-2a2.12,2.12,0,0,0,0-3.675l-3.458-2L3.192.288A2.127,2.127,0,0,0,0,2.13Z"
      transform="translate(4.415 3.887)"
      fill="#fff"
    />
  </SvgIcon>
);

export const GoogleIcon = () => (
  <SvgIcon width="15.66" height="15.999" viewBox="0 0 15.66 15.999">
    <g id="Google__G__Logo" transform="translate(26.754 -39.239)">
      <path
        id="Path_5579"
        data-name="Path 5579"
        d="M-7.094,50.752a9.269,9.269,0,0,0-.127-1.513h-7.533v3.007h4.313a3.714,3.714,0,0,1-1.6,2.387v2h2.573A7.822,7.822,0,0,0-7.094,50.752Z"
        transform="translate(-4 -3.333)"
        fill="#4285f4"
      />
      <path
        id="Path_5580"
        data-name="Path 5580"
        d="M-18.324,60a7.62,7.62,0,0,0,5.287-1.94l-2.573-2a4.826,4.826,0,0,1-2.713.773,4.778,4.778,0,0,1-4.487-3.307h-2.653v2.06A7.988,7.988,0,0,0-18.324,60Z"
        transform="translate(-0.43 -4.763)"
        fill="#34a853"
      />
      <path
        id="Path_5581"
        data-name="Path 5581"
        d="M-23.241,50.972a4.642,4.642,0,0,1-.253-1.527,4.823,4.823,0,0,1,.253-1.527v-2.06h-2.653a7.907,7.907,0,0,0-.86,3.587,7.907,7.907,0,0,0,.86,3.587Z"
        transform="translate(0 -2.207)"
        fill="#fbbc05"
      />
      <path
        id="Path_5582"
        data-name="Path 5582"
        d="M-18.324,42.406a4.34,4.34,0,0,1,3.067,1.2l2.28-2.28a7.649,7.649,0,0,0-5.347-2.087,7.988,7.988,0,0,0-7.14,4.413l2.653,2.06A4.778,4.778,0,0,1-18.324,42.406Z"
        transform="translate(-0.43)"
        fill="#ea4335"
      />
    </g>
  </SvgIcon>
);

export const SearchIcon = (props: SvgIconProps) => (
  <SvgIcon {...props} width="32" height="32" viewBox="0 0 32 32">
    <path id="Vector" d="M13.667,27.333A13.667,13.667,0,1,1,27.333,13.667,13.685,13.685,0,0,1,13.667,27.333ZM13.667,2A11.667,11.667,0,1,0,25.333,13.667,11.679,11.679,0,0,0,13.667,2Z" transform="translate(1.667 1.667)" fill="currentColor" />
    <path id="Vector-2" data-name="Vector" d="M3.663,4.663a.989.989,0,0,1-.707-.293L.29,1.7A1,1,0,0,1,1.7.29L4.37,2.957a1.006,1.006,0,0,1,0,1.413A.989.989,0,0,1,3.663,4.663Z" transform="translate(25.67 25.67)" fill="currentColor" />
    <path id="Vector-3" data-name="Vector" d="M0,0H32V32H0Z" fill="none" opacity="0" />
  </SvgIcon>
);

export const MeatballIcon = (props: SvgIconProps) => (
  <SvgIcon {...props} width="20" height="20" viewBox="0 0 20 20">
    <g id="Group_1768" data-name="Group 1768" transform="translate(7350 6100)">
      <path
        id="Vector"
        d="M2.083,0A2.083,2.083,0,1,0,4.167,2.083,2.089,2.089,0,0,0,2.083,0Z"
        transform="translate(-7347.917 -6092.083)"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      <path
        id="Vector-2"
        data-name="Vector"
        d="M2.083,0A2.083,2.083,0,1,0,4.167,2.083,2.089,2.089,0,0,0,2.083,0Z"
        transform="translate(-7336.25 -6092.083)"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      <path
        id="Vector-3"
        data-name="Vector"
        d="M2.083,0A2.083,2.083,0,1,0,4.167,2.083,2.089,2.089,0,0,0,2.083,0Z"
        transform="translate(-7342.083 -6092.083)"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      <path
        id="Vector-4"
        data-name="Vector"
        d="M0,0H20V20H0Z"
        transform="translate(-7350 -6100)"
        fill="none"
        opacity="0"
      />
    </g>
  </SvgIcon>
);

export const TrashIcon = (props: SvgIconProps) => (
  <SvgIcon {...props} width="18" height="18" viewBox="0 0 18 18">
    <g id="vuesax_bold_trash" data-name="vuesax/bold/trash" transform="translate(-108 -188)">
      <g id="trash" transform="translate(108 188)">
        <path
          id="Vector"
          d="M14.118,2.985c-1.208-.12-2.415-.21-3.63-.277V2.7l-.165-.975C10.21,1.035,10.045,0,8.29,0H6.325C4.578,0,4.413.99,4.293,1.717l-.157.96c-.7.045-1.395.09-2.092.158l-1.53.15A.561.561,0,1,0,.618,4.1l1.53-.15a59.8,59.8,0,0,1,11.865.158h.06a.568.568,0,0,0,.562-.51A.575.575,0,0,0,14.118,2.985Z"
          transform="translate(1.685 0.937)"
          fill="currentColor"
        />
        <path
          id="Vector-2"
          data-name="Vector"
          d="M11.1.293A.948.948,0,0,0,10.419,0H.939A.936.936,0,0,0,.257.293.966.966,0,0,0,0,1L.467,8.692c.082,1.14.187,2.565,2.8,2.565H8.087c2.617,0,2.723-1.417,2.805-2.565l.465-7.687A.972.972,0,0,0,11.1.293Z"
          transform="translate(3.321 5.813)"
          fill="currentColor"
        />
        <path
          id="Vector-3"
          data-name="Vector"
          d="M0,0H18V18H0Z"
          transform="translate(18 18) rotate(180)"
          fill="none"
          opacity="0"
        />
      </g>
    </g>
  </SvgIcon>
);

export const UploadIcon = (props: SvgIconProps) => (
  <SvgIcon {...props} width="18" height="18" viewBox="0 0 18 18">
    <g id="vuesax_bold_export" data-name="vuesax/bold/export" transform="translate(-492 -444)">
      <g id="export" transform="translate(492 444)">
        <path
          id="Vector"
          d="M14.355,0H8.063V4.11a.563.563,0,0,1-1.125,0V0H.645A.64.64,0,0,0,0,.645a7.174,7.174,0,0,0,7.5,7.5A7.174,7.174,0,0,0,15,.645.64.64,0,0,0,14.355,0Z"
          transform="translate(1.5 7.425)"
          fill="currentColor"
        />
        <path
          id="Vector-2"
          data-name="Vector"
          d="M3.263,1.918l1.17,1.17a.562.562,0,0,0,.795-.8L3.09.163a.566.566,0,0,0-.8,0L.165,2.3A.589.589,0,0,0,0,2.7a.556.556,0,0,0,.165.4.566.566,0,0,0,.8,0l1.17-1.17V4.993H3.255V1.918Z"
          transform="translate(6.3 2.432)"
          fill="currentColor"
        />
        <path
          id="Vector-3"
          data-name="Vector"
          d="M0,0H18V18H0Z"
          transform="translate(18 18) rotate(180)"
          fill="none"
          opacity="0"
        />
      </g>
    </g>
  </SvgIcon>
);

export const GalleryIcon = (props: SvgIconProps) => (
  <SvgIcon {...props} width="24" height="24" viewBox="0 0 24 24">
    <g
      id="vuesax_linear_gallery"
      data-name="vuesax/linear/gallery"
      transform="translate(-365 -244)"
    >
      <g id="gallery" transform="translate(365 244)">
        <path
          id="Vector"
          d="M6.952,19.863h5.959c4.966,0,6.952-1.986,6.952-6.952V6.952C19.863,1.986,17.877,0,12.911,0H6.952C1.986,0,0,1.986,0,6.952v5.959C0,17.877,1.986,19.863,6.952,19.863Z"
          transform="translate(2.068 2.068)"
          fill="none"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
        <path
          id="Vector-2"
          data-name="Vector"
          d="M4.137,2.068A2.068,2.068,0,1,1,2.068,0,2.068,2.068,0,0,1,4.137,2.068Z"
          transform="translate(6.952 5.959)"
          fill="none"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
        <path
          id="Vector-3"
          data-name="Vector"
          d="M0,7.19,4.889,3.767a2.161,2.161,0,0,1,2.618.145l.327.3a2.141,2.141,0,0,0,2.8,0L14.757.52a2.141,2.141,0,0,1,2.8,0L19.17,1.968"
          transform="translate(2.761 11.83)"
          fill="none"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
        <path id="Vector-4" data-name="Vector" d="M0,0H24V24H0Z" fill="none" opacity="0" />
      </g>
    </g>
  </SvgIcon>
);

// eslint-disable-next-line unused-imports/no-unused-vars
export const QuestionIcon = (props: SvgIconProps) => (
  <SvgIcon {...props} width="14" height="14" viewBox="0 0 14 14">
    <circle id="Ellipse_413" data-name="Ellipse 413" cx="7" cy="7" r="7" fill="#f2f2f2" />
    <path
      id="Path_5571"
      data-name="Path 5571"
      d="M1.532-3.047,1.488-4.883h.5a4.786,4.786,0,0,0,1.017-.1,1.384,1.384,0,0,0,.733-.389,1.186,1.186,0,0,0,.274-.846,1.112,1.112,0,0,0-.317-.84,1.162,1.162,0,0,0-.842-.306A1.154,1.154,0,0,0,2-7.059,1.119,1.119,0,0,0,1.7-6.23H.372A2.3,2.3,0,0,1,.656-7.42a2.087,2.087,0,0,1,.859-.823,2.836,2.836,0,0,1,1.351-.3,2.892,2.892,0,0,1,1.3.278,2.135,2.135,0,0,1,.886.8,2.341,2.341,0,0,1,.323,1.263,2.242,2.242,0,0,1-.334,1.268,2.013,2.013,0,0,1-.908.745A3.5,3.5,0,0,1,2.8-3.938l-.033.89Zm.624,2.5a.854.854,0,0,1-.629-.245.8.8,0,0,1-.246-.59.815.815,0,0,1,.246-.6.854.854,0,0,1,.629-.245.836.836,0,0,1,.624.245.824.824,0,0,1,.241.6.811.811,0,0,1-.241.59A.836.836,0,0,1,2.155-.544Z"
      transform="translate(4.328 11.545)"
    />
  </SvgIcon>
);

export const EditIcon = (props: SvgIconProps) => (
  <SvgIcon {...props} width="20" height="20" viewBox="0 0 20 20">
    <g id="edit-2">
      <path id="Vector" d="M15.524,1.285H.621A.637.637,0,0,1,0,.643.637.637,0,0,1,.621,0h14.9a.637.637,0,0,1,.621.643A.637.637,0,0,1,15.524,1.285Z" transform="translate(1.928 17.001)" fill="currentColor" />
      <path id="Vector-2" data-name="Vector" d="M6.13,1.263c-1.662-1.662-3.29-1.7-4.995,0L.1,2.3a.357.357,0,0,0-.086.343A6.964,6.964,0,0,0,4.751,7.38a.43.43,0,0,0,.1.017.343.343,0,0,0,.248-.1L6.13,6.258A3.541,3.541,0,0,0,7.39,3.782,3.528,3.528,0,0,0,6.13,1.263Z" transform="translate(9.603 1.719)" fill="currentColor" />
      <path id="Vector-3" data-name="Vector" d="M10.381,4.7c-.248-.12-.488-.24-.72-.377-.188-.111-.368-.231-.548-.36a5.173,5.173,0,0,1-.48-.368,1.045,1.045,0,0,1-.146-.129A7.246,7.246,0,0,1,7.6,2.57a1.044,1.044,0,0,1-.129-.154,4.983,4.983,0,0,1-.36-.471,4.7,4.7,0,0,1-.334-.505c-.137-.231-.257-.463-.377-.7C6.285.48,6.191.231,6.106,0L.725,5.381a1.031,1.031,0,0,0-.24.471L.022,9.133a1.756,1.756,0,0,0,.437,1.5,1.705,1.705,0,0,0,1.2.463,1.873,1.873,0,0,0,.308-.026l3.29-.463a.954.954,0,0,0,.471-.24l5.381-5.381C10.869,4.9,10.638,4.806,10.381,4.7Z" transform="translate(2.993 4.875)" fill="currentColor" />
      <path id="Vector-4" data-name="Vector" d="M0,0H20V20H0Z" transform="translate(20 20) rotate(180)" fill="none" opacity="0" />
    </g>
  </SvgIcon>
);

export const PinIcon = (props: SvgIconProps) => (
  <SvgIcon {...props} width="19.907" height="20" viewBox="0 0 19.907 20">
    <g id="Group_10871" data-name="Group 10871" transform="translate(-394.059 -341.966)">
      <rect id="Rectangle_7031" data-name="Rectangle 7031" width="19.907" height="19.907" transform="translate(394.059 342.059)" fill="none" />
      <path id="Icon_metro-pin" data-name="Icon metro-pin" d="M19.8,17.639l-6.752-3.854a1.743,1.743,0,0,0-2.367.626,1.7,1.7,0,0,0,.634,2.34l6.751,3.854a1.742,1.742,0,0,0,2.367-.627,1.7,1.7,0,0,0-.633-2.339Zm-5.568-4.167,5.251,3,1.786-4.914L17.639,9.486l-3.411,3.986ZM10.356,26.1l5.023-6.033-2.251-1.285L10.356,26.1ZM23.435,8.838l-4.5-2.569a1.307,1.307,0,0,0-1.775.47,1.276,1.276,0,0,0,.476,1.755l4.5,2.569a1.307,1.307,0,0,0,1.775-.47,1.277,1.277,0,0,0-.476-1.755Z" transform="translate(387.337 335.87)" fill="currentColor" />
    </g>
  </SvgIcon>
);

export const MessageIcon = (props: SvgIconProps) => (
  <SvgIcon {...props} width="20" height="20" viewBox="0 0 20 20">
    <g id="vuesax_bold_message" data-name="vuesax/bold/message" transform="translate(-684 -188)">
      <g id="message" transform="translate(684 188)">
        <path id="Vector" d="M12.419,0H4.14A4.132,4.132,0,0,0,0,4.123V9.9a4.132,4.132,0,0,0,4.14,4.123H5.382a.952.952,0,0,1,.662.331L7.286,16a1.176,1.176,0,0,0,1.987,0l1.242-1.648a.839.839,0,0,1,.662-.331h1.242A4.132,4.132,0,0,0,16.559,9.9V4.123A4.132,4.132,0,0,0,12.419,0ZM4.968,8.279A.828.828,0,1,1,5.8,7.451.825.825,0,0,1,4.968,8.279Zm3.312,0a.828.828,0,1,1,.828-.828A.825.825,0,0,1,8.28,8.279Zm3.312,0a.828.828,0,1,1,.828-.828A.825.825,0,0,1,11.591,8.279Z" transform="translate(1.72 1.72)" fill="currentColor" />
        <path id="Vector-2" data-name="Vector" d="M0,0H20V20H0Z" fill="none" opacity="0" />
        <path id="Vector-3" data-name="Vector" d="M0,0H20V20H0Z" transform="translate(20 20) rotate(180)" fill="none" opacity="0" />
      </g>
    </g>
  </SvgIcon>
);

export const HearIcon = (props: SvgIconProps) => (
  <SvgIcon {...props} width="19.907" height="20" viewBox="0 0 19.907 20">
    <g id="vuesax_bold_heart" data-name="vuesax/bold/heart" transform="translate(-236 -188)">
      <g id="heart" transform="translate(236 188)">
        <path id="Vector" d="M12.131,0A4.653,4.653,0,0,0,8.4,1.885,4.659,4.659,0,0,0,0,4.724a9.074,9.074,0,0,0,.437,2.8c1.327,4.226,5.419,6.752,7.443,7.445a1.821,1.821,0,0,0,1.042,0c2.025-.693,6.116-3.22,7.443-7.445a9.074,9.074,0,0,0,.437-2.8A4.7,4.7,0,0,0,12.131,0Z" transform="translate(1.599 2.479)" fill="currentColor" />
        <path id="Vector-2" data-name="Vector" d="M0,0H20V20H0Z" transform="translate(20 20) rotate(180)" fill="none" opacity="0" />
      </g>
    </g>
  </SvgIcon>
);

export const PlusSquareIcon = (props: SvgIconProps) => (
  <SvgIcon {...props} width="32" height="32" viewBox="0 0 32 32">
    <g id="vuesax_outline_close-square" data-name="vuesax/outline/close-square" transform="translate(-108 -316)">
      <g id="close-square" transform="translate(108 316)">
        <path id="Vector" d="M1,9.543A.989.989,0,0,1,.29,9.25a1.006,1.006,0,0,1,0-1.413L7.837.29A1,1,0,0,1,9.25,1.7L1.7,9.25A.967.967,0,0,1,1,9.543Z" transform="translate(9.253 16.001) rotate(-45)" fill="currentColor" />
        <path id="Vector-2" data-name="Vector" d="M8.543,9.543a.989.989,0,0,1-.707-.293L.29,1.7A1,1,0,0,1,1.7.29L9.25,7.837a1.006,1.006,0,0,1,0,1.413A.989.989,0,0,1,8.543,9.543Z" transform="translate(9.253 16.001) rotate(-45)" fill="currentColor" />
        <path id="Vector-3" data-name="Vector" d="M18.333,28.667h-8C3.093,28.667,0,25.573,0,18.333v-8C0,3.093,3.093,0,10.333,0h8c7.24,0,10.333,3.093,10.333,10.333v8C28.667,25.573,25.573,28.667,18.333,28.667ZM10.333,2C4.187,2,2,4.187,2,10.333v8c0,6.147,2.187,8.333,8.333,8.333h8c6.147,0,8.333-2.187,8.333-8.333v-8C26.667,4.187,24.48,2,18.333,2Z" transform="translate(1.667 1.667)" fill="currentColor" />
        <path id="Vector-4" data-name="Vector" d="M0,0H32V32H0Z" fill="none" opacity="0" />
      </g>
    </g>
  </SvgIcon>
);

export const PlusIcon = (props: SvgIconProps) => (
  <SvgIcon {...props} width="20" height="20" viewBox="0 0 20 20">
    <g id="add">
      <path id="Vector" d="M10.625,1.25h-10A.63.63,0,0,1,0,.625.63.63,0,0,1,.625,0h10a.63.63,0,0,1,.625.625A.63.63,0,0,1,10.625,1.25Z" transform="translate(4.375 9.375)" fill="currentColor" />
      <path id="Vector-2" data-name="Vector" d="M.625,11.25A.63.63,0,0,1,0,10.625v-10A.63.63,0,0,1,.625,0,.63.63,0,0,1,1.25.625v10A.63.63,0,0,1,.625,11.25Z" transform="translate(9.375 4.375)" fill="currentColor" />
      <path id="Vector-3" data-name="Vector" d="M0,0H20V20H0Z" fill="none" opacity="0" />
    </g>
  </SvgIcon>
);

export const ClipBoardIcon = (props: SvgIconProps) => (
  <SvgIcon {...props} width="32" height="32" viewBox="0 0 32 32">
    <g id="clipboard-text" transform="translate(0 0)">
      <path id="Vector" d="M8.787,0H2.52A2.515,2.515,0,0,0,0,2.507V3.76A2.5,2.5,0,0,0,2.507,6.267h6.28A2.5,2.5,0,0,0,11.293,3.76V2.507A2.5,2.5,0,0,0,8.787,0Z" transform="translate(10.347 2.667)" fill="currentColor" />
      <path id="Vector-2" data-name="Vector" d="M18.6.983a3.864,3.864,0,0,1-3.853,3.853H8.48A3.864,3.864,0,0,1,4.627.983,1,1,0,0,0,3.16.117,5.962,5.962,0,0,0,0,5.383V17.93a5.975,5.975,0,0,0,5.96,5.96H17.267a5.975,5.975,0,0,0,5.96-5.96V5.383A5.962,5.962,0,0,0,20.067.117,1,1,0,0,0,18.6.983ZM12.12,17.157H6.28a1,1,0,0,1,0-2h5.84a1,1,0,0,1,0,2Zm3.493-5.333H6.28a1,1,0,1,1,0-2h9.333a1,1,0,1,1,0,2Z" transform="translate(4.387 5.443)" fill="currentColor" />
      <path id="Vector-3" data-name="Vector" d="M0,0H32V32H0Z" transform="translate(32 32) rotate(180)" fill="none" opacity="0" />
    </g>
  </SvgIcon>
);

export const MediaIcon = (props: SvgIconProps) => (
  <SvgIcon {...props} width="32" height="32" viewBox="0 0 32 32">
    <path id="Vector" d="M15.885,1.176,9.631.189C4.418-.624,2,1.136,1.178,6.349L.191,12.6c-.533,3.413.027,5.627,1.96,6.973a9.8,9.8,0,0,0,4.2,1.48l6.253.987c5.213.813,7.627-.947,8.453-6.16l.973-6.253a12.764,12.764,0,0,0,.173-2.76C22.031,3.536,20.071,1.829,15.885,1.176ZM8.351,9.8a2.82,2.82,0,1,1,2.813-2.813A2.825,2.825,0,0,1,8.351,9.8Z" transform="translate(2.635 2.664)" fill="currentColor" />
    <path id="Vector-2" data-name="Vector" d="M21.48,7.547l-2,6.013c-1.667,5.013-4.333,6.347-9.347,4.68l-6.013-2A9.466,9.466,0,0,1,0,13.867a13.671,13.671,0,0,0,2.92.76l6.267.987a15.592,15.592,0,0,0,2.4.2c4.4,0,6.76-2.373,7.573-7.48l.973-6.253A12.129,12.129,0,0,0,20.32,0C22.347,1.667,22.64,4.04,21.48,7.547Z" transform="translate(5.853 10.413)" fill="currentColor" />
    <path id="Vector-3" data-name="Vector" d="M0,0H32V32H0Z" transform="translate(32 32) rotate(180)" fill="none" opacity="0" />
  </SvgIcon>
);

export const CloseSquareIcon = (props: SvgIconProps) => (
  <SvgIcon {...props} width="32" height="32" viewBox="0 0 32 32">
    <g id="close-square" transform="translate(0 0)">
      <path id="Vector" d="M1,9.543A.989.989,0,0,1,.29,9.25a1.006,1.006,0,0,1,0-1.413L7.837.29A1,1,0,0,1,9.25,1.7L1.7,9.25A.967.967,0,0,1,1,9.543Z" transform="translate(11.23 11.23)" fill="currentColor" />
      <path id="Vector-2" data-name="Vector" d="M8.543,9.543a.989.989,0,0,1-.707-.293L.29,1.7A1,1,0,0,1,1.7.29L9.25,7.837a1.006,1.006,0,0,1,0,1.413A.989.989,0,0,1,8.543,9.543Z" transform="translate(11.23 11.23)" fill="currentColor" />
      <path id="Vector-3" data-name="Vector" d="M18.333,28.667h-8C3.093,28.667,0,25.573,0,18.333v-8C0,3.093,3.093,0,10.333,0h8c7.24,0,10.333,3.093,10.333,10.333v8C28.667,25.573,25.573,28.667,18.333,28.667ZM10.333,2C4.187,2,2,4.187,2,10.333v8c0,6.147,2.187,8.333,8.333,8.333h8c6.147,0,8.333-2.187,8.333-8.333v-8C26.667,4.187,24.48,2,18.333,2Z" transform="translate(1.667 1.667)" fill="currentColor" />
      <path id="Vector-4" data-name="Vector" d="M0,0H32V32H0Z" fill="none" opacity="0" />
    </g>
  </SvgIcon>
);

export const CloseIcon = (props: SvgIconProps) => (
  <SvgIcon {...props} width="32" height="32" viewBox="0 0 32 32">
    <g id="Group_12582" data-name="Group 12582" transform="translate(-0.402)">
      <rect id="Rectangle_7264" data-name="Rectangle 7264" width="32" height="32" transform="translate(0.402)" fill="none" />
      <g id="Group_12214" data-name="Group 12214" transform="translate(8.647 8.246)">
        <path id="Vector" d="M0,16.492,16.493,0" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" />
        <path id="Vector-2" data-name="Vector" d="M16.493,16.492,0,0" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" />
      </g>
    </g>
  </SvgIcon>
);

export const MonitorIcon = (props: SvgIconProps) => (
  <SvgIcon {...props} width="32" height="32" viewBox="0 0 32 32">
    <g id="monitor" transform="translate(0 0)">
      <path id="Vector" d="M20.747,0H5.88A5.89,5.89,0,0,0,0,5.88v8.933a5.881,5.881,0,0,0,5.88,5.88H11a1.337,1.337,0,0,1,1.333,1.333V23.32A1.337,1.337,0,0,1,11,24.653H7.773a1.007,1.007,0,0,0,0,2.013H18.907a1,1,0,0,0,0-2H15.68a1.337,1.337,0,0,1-1.333-1.333V22.04a1.337,1.337,0,0,1,1.333-1.333h5.08a5.881,5.881,0,0,0,5.88-5.88V5.893A5.912,5.912,0,0,0,20.747,0Z" transform="translate(2.667 2.667)" fill="currentColor" />
      <path id="Vector-2" data-name="Vector" d="M0,0H32V32H0Z" transform="translate(32 32) rotate(180)" fill="none" opacity="0" />
    </g>
  </SvgIcon>
);

export const SuccessCircleIcon = (props: SvgIconProps) => (
  <SvgIcon {...props} width="60" height="60" viewBox="0 0 60 60">
    <g id="vuesax_outline_tick-circle" data-name="vuesax/outline/tick-circle" transform="translate(-748 -188)">
      <g id="tick-circle" transform="translate(748 188)">
        <path id="Vector" d="M26.875,53.75A26.875,26.875,0,1,1,53.75,26.875,26.9,26.9,0,0,1,26.875,53.75Zm0-50A23.125,23.125,0,1,0,50,26.875,23.153,23.153,0,0,0,26.875,3.75Z" transform="translate(3.125 3.125)" fill="#3dcc96" />
        <path id="Vector-2" data-name="Vector" d="M8.944,17.919a1.873,1.873,0,0,1-1.325-.55L.544,10.294a1.874,1.874,0,0,1,2.65-2.65l5.75,5.75L21.794.544a1.874,1.874,0,0,1,2.65,2.65L10.269,17.369A1.873,1.873,0,0,1,8.944,17.919Z" transform="translate(17.506 21.031)" fill="#3dcc96" />
        <path id="Vector-3" data-name="Vector" d="M0,0H60V60H0Z" fill="none" opacity="0" />
      </g>
    </g>
  </SvgIcon>
);

export const ErrorCircleIcon = (props: SvgIconProps) => (
  <SvgIcon {...props} width="60" height="60" viewBox="0 0 60 60">
    <g id="vuesax_outline_add-circle" data-name="vuesax/outline/add-circle" transform="translate(-108 -252)">
      <g id="add-circle" transform="translate(108 252)">
        <path id="Vector" d="M26.875,53.75A26.875,26.875,0,1,1,53.75,26.875,26.9,26.9,0,0,1,26.875,53.75Zm0-50A23.125,23.125,0,1,0,50,26.875,23.153,23.153,0,0,0,26.875,3.75Z" transform="translate(3.125 3.125)" fill="#ff5858" />
        <path id="Vector-2" data-name="Vector" d="M21.875,3.75h-20A1.889,1.889,0,0,1,0,1.875,1.889,1.889,0,0,1,1.875,0h20A1.889,1.889,0,0,1,23.75,1.875,1.889,1.889,0,0,1,21.875,3.75Z" transform="translate(22.929 20.278) rotate(45)" fill="#ff5858" />
        <path id="Vector-3" data-name="Vector" d="M1.875,23.75A1.889,1.889,0,0,1,0,21.875v-20A1.889,1.889,0,0,1,1.875,0,1.889,1.889,0,0,1,3.75,1.875v20A1.889,1.889,0,0,1,1.875,23.75Z" transform="translate(37.071 20.278) rotate(45)" fill="#ff5858" />
        <path id="Vector-4" data-name="Vector" d="M0,0H60V60H0Z" fill="none" opacity="0" />
      </g>
    </g>
  </SvgIcon>
);

export const WarningCircleIcon = (props: SvgIconProps) => (
  <SvgIcon {...props} width="60" height="60" viewBox="0 0 60 60">
    <g id="surface1">
      <path fill="#f5b71e" d="M 30 56.875 C 15.15625 56.875 3.128906 44.84375 3.128906 30 C 3.128906 15.160156 15.160156 3.128906 30 3.128906 C 44.84375 3.128906 56.875 15.15625 56.875 30 C 56.863281 44.839844 44.839844 56.863281 30 56.875 Z M 30 6.875 C 17.230469 6.875 6.875 17.230469 6.878906 30 C 6.878906 42.773438 17.230469 53.125 30.003906 53.125 C 42.773438 53.125 53.125 42.769531 53.125 30 C 53.109375 17.234375 42.765625 6.890625 30 6.875 Z M 30 6.875 " />
      <path fill="#f5b71e" d="M 30 34.375 C 28.96875 34.367188 28.132812 33.535156 28.125 32.5 L 28.125 20 C 28.132812 18.96875 28.96875 18.132812 30 18.125 C 31.03125 18.132812 31.867188 18.96875 31.875 20 L 31.875 32.5 C 31.867188 33.535156 31.03125 34.367188 30 34.375 Z M 30 34.375 " />
      <path
        fill="#f5b71e"
        d="M 30 42.5 C 29.671875 42.496094 29.351562 42.429688 29.050781 42.300781 C 28.746094 42.171875 28.46875 41.996094 28.222656 41.773438 C 28 41.535156 27.820312 41.257812 27.699219 40.949219 C 27.570312 40.648438 27.503906 40.328125 27.5 40 C 27.503906 39.675781 27.574219 39.351562 27.703125 39.050781 C 27.828125 38.746094 28.003906 38.46875 28.226562 38.226562 C 28.46875 38.003906 28.75 37.828125 29.050781 37.699219 C 29.660156 37.449219 30.34375 37.449219 30.949219 37.699219 C 31.253906 37.828125 31.53125 38.003906 31.777344 38.226562 C 31.996094 38.46875 32.171875 38.746094 32.300781 39.050781 C 32.429688 39.351562 32.496094 39.675781 32.5 40 C 32.496094 40.328125 32.429688 40.652344 32.300781 40.953125 C 32.179688 41.257812 32 41.539062 31.777344 41.777344 C 31.53125 41.996094 31.253906 42.175781 30.949219 42.300781 C 30.648438 42.429688 30.328125 42.496094 30 42.5 Z M 30 42.5 "
      />
    </g>
  </SvgIcon>
);

export const ArrowCircleRight = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" width={24} height={24} {...props}>
    <g
      fill="none"
      stroke="#333"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
    >
      <path d="M22 12A10 10 0 1 1 12 2a10 10 0 0 1 10 10Z" />
      <path data-name="Vector" d="M10.74 15.53 14.26 12l-3.52-3.53" />
    </g>
  </svg>
);

export const ArrowCircleLeft = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" width={24} height={24} {...props}>
    <g
      fill="none"
      stroke="#333"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
    >
      <path d="M22 12A10 10 0 1 1 12 2a10 10 0 0 1 10 10Z" />
      <path data-name="Vector" d="M13.26 15.53 9.74 12l3.52-3.53" />
    </g>
  </svg>
);

export const HeartIcon = (props: SvgIconProps) => (
  <SvgIcon viewBox="0 0 33 33" {...props}>
    <path
      d="M22.716 3.6A7.685 7.685 0 0 0 16.5 6.832 7.685 7.685 0 0 0 10.284 3.6 7.946 7.946 0 0 0 2.5 11.7a15.979 15.979 0 0 0 .728 4.8c2.212 7.247 9.03 11.581 12.4 12.77a2.953 2.953 0 0 0 1.736 0c3.374-1.189 10.192-5.522 12.4-12.77a15.979 15.979 0 0 0 .736-4.8 7.946 7.946 0 0 0-7.784-8.1Z"
      stroke="rgba(0,0,0,0)"
      data-name="vuesax/bold/heart"
    />
  </SvgIcon>
);

export const EyeIcon = (props: SvgIconProps) => (
  <SvgIcon viewBox="0 0 32 32" {...props}>
    <path id="Vector" d="M24.383,6.862C21.457,2.507,17.176,0,12.667,0A12.771,12.771,0,0,0,6.219,1.787,16.482,16.482,0,0,0,.95,6.862a6.606,6.606,0,0,0,0,6.826c2.926,4.367,7.207,6.862,11.717,6.862a12.771,12.771,0,0,0,6.447-1.787,16.482,16.482,0,0,0,5.269-5.075A6.606,6.606,0,0,0,24.383,6.862ZM12.667,15.128a4.981,4.981,0,0,1-5.117-4.847,4.981,4.981,0,0,1,5.117-4.847,4.981,4.981,0,0,1,5.117,4.847A4.981,4.981,0,0,1,12.667,15.128Z" transform="translate(3.333 5.717)" />
    <path id="Vector-2" data-name="Vector" d="M3.029,0a3.035,3.035,0,1,0,3.04,3.04A3.037,3.037,0,0,0,3.029,0Z" transform="translate(12.972 12.959)" />
    <path id="Vector-3" data-name="Vector" d="M0,0H32V32H0Z" transform="translate(32 32) rotate(180)" fill="none" opacity="0" />
  </SvgIcon>
);

export const BookmarkIcon = (props: SvgIconProps) => (
  <SvgIcon viewBox="0 0 16 16" {...props}>
    <g id="vuesax_bold_archive-tick" data-name="vuesax/bold/archive-tick" transform="translate(-108 -191)">
      <g id="archive-tick" transform="translate(108 191)">
        <path id="Vector" d="M9,0H2.573A2.583,2.583,0,0,0,0,2.573v9.393c0,1.2.86,1.707,1.913,1.127l3.253-1.807a1.412,1.412,0,0,1,1.247,0l3.253,1.807c1.053.587,1.913.08,1.913-1.127V2.573A2.589,2.589,0,0,0,9,0ZM8.2,4.747,5.533,7.413a.5.5,0,0,1-.707,0l-1-1a.5.5,0,0,1,.707-.707l.647.647L7.493,4.04a.5.5,0,0,1,.707.707Z" transform="translate(2.213 1.273)" fill="currentColor" />
        <path id="Vector-2" data-name="Vector" d="M0,0H16V16H0Z" transform="translate(16 16) rotate(180)" fill="none" opacity="0" />
      </g>
    </g>
  </SvgIcon>
);

export const ArrowUpIcon = (props: SvgIconProps) => (
  <SvgIcon viewBox="0 0 16 16" {...props}>
    <path id="Vector" d="M10.56,0,6.213,4.347a1.324,1.324,0,0,1-1.867,0L0,0" transform="translate(2.72 5.967)" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" />
    <path id="Vector-2" data-name="Vector" d="M0,0H16V16H0Z" transform="translate(16 16) rotate(180)" fill="none" opacity="0" />
  </SvgIcon>
);

export const TranslateIcon = (props: SvgIconProps) => (
  <SvgIcon viewBox="0 0 16 16" {...props}>
    <g id="vuesax_bold_translate" data-name="vuesax/bold/translate" transform="translate(-748 -316)">
      <g id="translate" transform="translate(748 316)">
        <path id="Vector" d="M0,0H16V16H0Z" transform="translate(16 16) rotate(180)" fill="none" opacity="0" />
        <path id="Vector-2" data-name="Vector" d="M4.674,0H2.037A1.8,1.8,0,0,0,0,2.037V4.681C0,6.07.674,6.745,2.037,6.711H4.681a1.745,1.745,0,0,0,2.03-2.037V2.037C6.745.674,6.07,0,4.674,0Zm.054,5.234a1.991,1.991,0,0,1-1.275-.486,2.5,2.5,0,0,1-1.47.486.506.506,0,1,1,0-1.012A1.565,1.565,0,0,0,3.453,3.1H1.983a.506.506,0,1,1,0-1.012h.87a.5.5,0,0,1,1,0h.87a.506.506,0,1,1,0,1.012H4.5a2.7,2.7,0,0,1-.357.9.984.984,0,0,0,.587.216.506.506,0,0,1,0,1.012Z" transform="translate(1.349 1.349)" fill="currentColor" />
        <path id="Vector-3" data-name="Vector" d="M5.227,5.733A5.236,5.236,0,0,1,0,.506.51.51,0,0,1,.506,0a.51.51,0,0,1,.506.506A4.223,4.223,0,0,0,4.269,4.613l-.182-.3a.507.507,0,0,1,.87-.519l.708,1.18a.5.5,0,0,1,.007.506A.527.527,0,0,1,5.227,5.733Z" transform="translate(0.843 9.424)" fill="currentColor" />
        <path id="Vector-4" data-name="Vector" d="M5.231,5.733a.51.51,0,0,1-.506-.506A4.223,4.223,0,0,0,1.468,1.12l.182.3a.507.507,0,0,1-.87.519L.072.762A.5.5,0,0,1,.065.256.527.527,0,0,1,.51,0,5.236,5.236,0,0,1,5.737,5.227.51.51,0,0,1,5.231,5.733Z" transform="translate(9.42 0.843)" fill="currentColor" />
        <path id="Vector-5" data-name="Vector" d="M3.426,0A3.426,3.426,0,1,0,6.853,3.426,3.427,3.427,0,0,0,3.426,0ZM5.1,5.052a.508.508,0,0,1-.681-.229L4.3,4.593H2.556l-.115.229A.508.508,0,0,1,1.99,5.1a.51.51,0,0,1-.452-.735l1.443-2.88a.513.513,0,0,1,.452-.277.507.507,0,0,1,.452.283l1.443,2.88A.514.514,0,0,1,5.1,5.052Z" transform="translate(7.798 7.805)" fill="currentColor" />
        <path id="Vector-6" data-name="Vector" d="M0,.735H.735L.364,0Z" transform="translate(10.914 10.707)" fill="currentColor" />
      </g>
    </g>
  </SvgIcon>
);

export const EllipseVerticalIcon = (props: SvgIconProps) => (
  <SvgIcon viewBox="0 0 20 20" {...props}>
    <g id="Group_1768" data-name="Group 1768" transform="translate(20) rotate(90)">
      <path id="Vector" d="M2.083,0A2.083,2.083,0,1,0,4.167,2.083,2.089,2.089,0,0,0,2.083,0Z" transform="translate(2.083 7.917)" fill="currentColor" />
      <path id="Vector-2" data-name="Vector" d="M2.083,0A2.083,2.083,0,1,0,4.167,2.083,2.089,2.089,0,0,0,2.083,0Z" transform="translate(13.75 7.917)" fill="currentColor" />
      <path id="Vector-3" data-name="Vector" d="M2.083,0A2.083,2.083,0,1,0,4.167,2.083,2.089,2.089,0,0,0,2.083,0Z" transform="translate(7.917 7.917)" fill="currentColor" />
      <path id="Vector-4" data-name="Vector" d="M0,0H20V20H0Z" fill="none" opacity="0" />
    </g>
  </SvgIcon>
);

export const SquareMenuIcon = (props: SvgIconProps) => (
  <SvgIcon {...props} viewBox="0 0 20 20">
    <g id="vuesax_bold_menu" data-name="vuesax/bold/menu" transform="translate(-236 -256)">
      <g id="menu" transform="translate(236 256)">
        <path id="Vector" d="M0,0H20V20H0Z" fill="none" opacity="0" />
        <path id="Vector-2" data-name="Vector" d="M4.969,2.485A2.485,2.485,0,1,1,2.485,0,2.485,2.485,0,0,1,4.969,2.485Z" transform="translate(11.093 3.426)" fill="#b2b2b2" />
        <path id="Vector-3" data-name="Vector" d="M4.969,2.485A2.485,2.485,0,1,1,2.485,0,2.485,2.485,0,0,1,4.969,2.485Z" transform="translate(3.938 3.426)" fill="#b2b2b2" />
        <path id="Vector-4" data-name="Vector" d="M4.969,2.485A2.485,2.485,0,1,1,2.485,0,2.485,2.485,0,0,1,4.969,2.485Z" transform="translate(11.093 11.605)" fill="#b2b2b2" />
        <path id="Vector-5" data-name="Vector" d="M4.969,2.485A2.485,2.485,0,1,1,2.485,0,2.485,2.485,0,0,1,4.969,2.485Z" transform="translate(3.938 11.605)" fill="#b2b2b2" />
      </g>
    </g>
  </SvgIcon>
);

export const ArrowRightIcon = (props: SvgIconProps) => (
  <SvgIcon width="32" height="32" viewBox="0 0 32 32" {...props}>
    <g id="vuesax_outline_arrow-right" data-name="vuesax/outline/arrow-right" transform="translate(-620 -188)">
      <g id="arrow-right" transform="translate(620 188)">
        <path id="Vector" d="M1,18.183A.989.989,0,0,1,.29,17.89a1.006,1.006,0,0,1,0-1.413L7.677,9.09.29,1.7A1,1,0,0,1,1.7.29L9.8,8.383A1.006,1.006,0,0,1,9.8,9.8L1.7,17.89A.989.989,0,0,1,1,18.183Z" transform="translate(18.243 6.91)" fill="currentColor" />
        <path id="Vector-2" data-name="Vector" d="M23.44,2H1A1.007,1.007,0,0,1,0,1,1.007,1.007,0,0,1,1,0H23.44a1.007,1.007,0,0,1,1,1A1.007,1.007,0,0,1,23.44,2Z" transform="translate(3.667 15)" fill="currentColor" />
        <path id="Vector-3" data-name="Vector" d="M0,0H32V32H0Z" fill="none" opacity="0" />
      </g>
    </g>
  </SvgIcon>
);

export const ArrowSquareUpIcon = (props: SvgIconProps) => (
  <SvgIcon {...props} viewBox="0 0 32 32">
    <g id="vuesax_linear_arrow-square-up" data-name="vuesax/linear/arrow-square-up" transform="translate(-364 -188)">
      <g id="arrow-square-up" transform="translate(364 188)">
        <path id="Vector" d="M9.3,26.585H17.28c6.646,0,9.3-2.658,9.3-9.3V9.3c0-6.646-2.658-9.3-9.3-9.3H9.3C2.658,0,0,2.658,0,9.3V17.28C0,23.926,2.658,26.585,9.3,26.585Z" transform="translate(2.708 2.708)" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" />
        <path id="Vector-2" data-name="Vector" d="M0,4.766,4.779,0,9.558,4.766" transform="translate(11.221 13.218)" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" />
        <path id="Vector-3" data-name="Vector" d="M0,0H32V32H0Z" transform="translate(32 32) rotate(180)" fill="none" opacity="0" />
      </g>
    </g>
  </SvgIcon>
);

export const ArrowSquareDownIcon = (props: SvgIconProps) => (
  <SvgIcon {...props} viewBox="0 0 16 16">
    <g id="vuesax_linear_arrow-square-up" data-name="vuesax/linear/arrow-square-up" transform="translate(380 204) rotate(180)">
      <g id="arrow-square-up" transform="translate(364 188)">
        <path id="Vector" d="M4.652,13.292H8.64c3.323,0,4.652-1.329,4.652-4.652V4.652C13.292,1.329,11.963,0,8.64,0H4.652C1.329,0,0,1.329,0,4.652V8.64C0,11.963,1.329,13.292,4.652,13.292Z" transform="translate(1.354 1.354)" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" />
        <path id="Vector-2" data-name="Vector" d="M0,2.383,2.39,0l2.39,2.383" transform="translate(5.61 6.609)" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" />
        <path id="Vector-3" data-name="Vector" d="M0,0H16V16H0Z" transform="translate(16 16) rotate(180)" fill="none" opacity="0" />
      </g>
    </g>
  </SvgIcon>
);

export const YoutubeIcon = (props: SvgIconProps) => (
  <SvgIcon {...props} viewBox="0 0 24 24">
    <g id="youtube">
      <path id="BG_165" data-name="BG 165" d="M0,0H24V24H0Z" fill="none" opacity="0.58" />
      <path id="Vector" d="M15,0H5A4.724,4.724,0,0,0,0,5v6a4.724,4.724,0,0,0,5,5H15a4.724,4.724,0,0,0,5-5V5A4.724,4.724,0,0,0,15,0ZM11.89,9.03,9.42,10.51c-1,.6-1.82.14-1.82-1.03V6.51c0-1.17.82-1.63,1.82-1.03l2.47,1.48A1.108,1.108,0,0,1,11.89,9.03Z" transform="translate(2 4)" fill="red" />
      <path id="Vector-2" data-name="Vector" d="M0,0H24V24H0Z" fill="none" opacity="0" />
    </g>
  </SvgIcon>
);

export const CloseSquareFillIcon = (props: SvgIconProps) => (
  <SvgIcon {...props} viewBox="0 0 32 32">
    <g id="vuesax_bold_close-square" data-name="vuesax/bold/close-square" transform="translate(-108 -316)">
      <g id="close-square" transform="translate(108 316)">
        <path id="Vector" d="M18.92,0H7.747C2.893,0,0,2.893,0,7.747v11.16c0,4.867,2.893,7.76,7.747,7.76h11.16c4.853,0,7.747-2.893,7.747-7.747V7.747C26.667,2.893,23.773,0,18.92,0ZM17.813,16.4a1.006,1.006,0,0,1,0,1.413,1,1,0,0,1-1.413,0l-3.067-3.067-3.067,3.067a1,1,0,0,1-1.413,0,1.006,1.006,0,0,1,0-1.413l3.067-3.067L8.853,10.267a1,1,0,0,1,1.413-1.413l3.067,3.067L16.4,8.853a1,1,0,0,1,1.413,1.413l-3.067,3.067Z" transform="translate(2.667 2.667)" fill="currentColor" />
        <path id="Vector-2" data-name="Vector" d="M0,0H32V32H0Z" transform="translate(32 32) rotate(180)" fill="none" opacity="0" />
      </g>
    </g>
  </SvgIcon>
);

export const UploadSquareFillIcon = (props: SvgIconProps) => (
  <SvgIcon {...props} viewBox="0 0 32 32">
    <g id="vuesax_bold_document-upload" data-name="vuesax/bold/document-upload" transform="translate(-364 -188)">
      <g id="document-upload" transform="translate(364 188)">
        <path id="Vector" d="M24,10.92H20.147a5.742,5.742,0,0,1-5.733-5.733V1.333A1.337,1.337,0,0,0,13.08,0H7.427C3.32,0,0,2.667,0,7.427V19.24C0,24,3.32,26.667,7.427,26.667h10.48c4.107,0,7.427-2.667,7.427-7.427V12.253A1.337,1.337,0,0,0,24,10.92ZM12.04,15.373a1,1,0,0,1-1.413,0l-.96-.96V20a1,1,0,1,1-2,0V14.413l-.96.96A1,1,0,0,1,5.293,13.96L7.96,11.293a1.427,1.427,0,0,1,.293-.2c.027-.013.067-.027.093-.04A1.416,1.416,0,0,1,8.6,11h.107a.917.917,0,0,1,.32.067h.027a.883.883,0,0,1,.293.2c.013.013.027.013.027.027L12.04,13.96A1.006,1.006,0,0,1,12.04,15.373Z" transform="translate(3.333 2.667)" fill="currentColor" />
        <path id="Vector-2" data-name="Vector" d="M3.667,9.06c1.267.013,3.027.013,4.533.013a.841.841,0,0,0,.627-1.427C6.907,5.713,3.467,2.233,1.493.26A.871.871,0,0,0,0,.846V5.5A3.635,3.635,0,0,0,3.667,9.06Z" transform="translate(19.573 2.687)" fill="currentColor" />
        <path id="Vector-3" data-name="Vector" d="M0,0H32V32H0Z" transform="translate(32 32) rotate(180)" fill="none" opacity="0" />
      </g>
    </g>
  </SvgIcon>
);

export const MaximizeWebCamIcon = (props: SvgIconProps) => (
  <SvgIcon {...props} width="32" height="32" viewBox="0 0 32 32">
    <g id="vuesax_outline_maximize-circle" data-name="vuesax/outline/maximize-circle" transform="translate(-300 -636)">
      <g id="maximize-circle" transform="translate(300 636)">
        <path id="Vector" d="M6.333,7.333a1.007,1.007,0,0,1-1-1V2H1A1.007,1.007,0,0,1,0,1,1.007,1.007,0,0,1,1,0H6.333a1.007,1.007,0,0,1,1,1V6.333A1.007,1.007,0,0,1,6.333,7.333Z" transform="translate(21.667 3)" fill="currentColor" />
        <path id="Vector-2" data-name="Vector" d="M1,10A.989.989,0,0,1,.29,9.7a1.006,1.006,0,0,1,0-1.413l8-8A1,1,0,0,1,9.7,1.7l-8,8A.989.989,0,0,1,1,10Z" transform="translate(19.003 3.003)" fill="currentColor" />
        <path id="Vector-3" data-name="Vector" d="M6.333,7.333H1a1.007,1.007,0,0,1-1-1V1A1.007,1.007,0,0,1,1,0,1.007,1.007,0,0,1,2,1V5.333H6.333a1,1,0,0,1,0,2Z" transform="translate(3 21.667)" fill="currentColor" />
        <path id="Vector-4" data-name="Vector" d="M1,10A.989.989,0,0,1,.29,9.7a1.006,1.006,0,0,1,0-1.413l8-8A1,1,0,0,1,9.7,1.7l-8,8A.989.989,0,0,1,1,10Z" transform="translate(3.003 19.003)" fill="currentColor" />
        <path id="Vector-5" data-name="Vector" d="M1.267,18a1,1,0,0,1-.973-.8A14.726,14.726,0,0,1,0,14.333,14.345,14.345,0,0,1,14.333,0a14.017,14.017,0,0,1,2.893.293,1,1,0,0,1,.787,1.173,1.016,1.016,0,0,1-1.173.787A12.964,12.964,0,0,0,14.347,2,12.348,12.348,0,0,0,2.013,14.333,11.734,11.734,0,0,0,2.267,16.8a.992.992,0,0,1-.787,1.173A.624.624,0,0,1,1.267,18Z" transform="translate(1.667 1.667)" fill="currentColor" />
        <path id="Vector-6" data-name="Vector" d="M3.7,17.993A14.016,14.016,0,0,1,.806,17.7a1,1,0,0,1-.787-1.173,1.016,1.016,0,0,1,1.173-.787,12.964,12.964,0,0,0,2.493.253A12.348,12.348,0,0,0,16.019,3.659a12.783,12.783,0,0,0-.24-2.467,1,1,0,0,1,1.96-.387,14.58,14.58,0,0,1,.28,2.853A14.325,14.325,0,0,1,3.7,17.993Z" transform="translate(12.301 12.341)" fill="currentColor" />
        <path id="Vector-7" data-name="Vector" d="M0,0H32V32H0Z" fill="none" opacity="0" />
      </g>
    </g>
  </SvgIcon>
);

export const MaximizeSquareFillIcon = (props: SvgIconProps) => (
  <SvgIcon {...props} viewBox="0 0 31 31">
    <g id="vuesax_bold_maximize-4" data-name="vuesax/bold/maximize-4" transform="translate(-108 -380)">
      <g id="maximize-4" transform="translate(108 380)">
        <path id="Vector" d="M18.329,0H7.5C2.8,0,0,2.8,0,7.5V18.316c0,4.715,2.8,7.517,7.5,7.517H18.316c4.7,0,7.5-2.8,7.5-7.5V7.5C25.833,2.8,23.03,0,18.329,0ZM12.31,14.893,7.5,19.7h2.829a.969.969,0,0,1,0,1.938H5.167a.927.927,0,0,1-.375-.077,1.011,1.011,0,0,1-.53-.53,1.121,1.121,0,0,1-.065-.362V15.5a.969.969,0,0,1,1.938,0v2.829l4.8-4.8a.968.968,0,0,1,1.369,1.369Zm9.326-4.56a.969.969,0,0,1-1.937,0V7.5l-4.805,4.8a.967.967,0,0,1-1.369,0,.975.975,0,0,1,0-1.369l4.8-4.8H15.5a.969.969,0,0,1,0-1.937h5.167a.973.973,0,0,1,.375.077,1.011,1.011,0,0,1,.53.53,1.121,1.121,0,0,1,.065.362Z" transform="translate(2.583 2.583)" fill="currentColor" />
        <path id="Vector-2" data-name="Vector" d="M0,0H31V31H0Z" transform="translate(31 31) rotate(180)" fill="none" opacity="0" />
      </g>
    </g>
  </SvgIcon>
);

export const MiniimizeSquareFillIcon = (props: SvgIconProps) => (
  <SvgIcon {...props} width="24" height="24" viewBox="0 0 24 24">
    <g id="vuesax_bold_import" data-name="vuesax/bold/import" transform="translate(-236 -508)">
      <g id="import">
        <path id="Vector" d="M14.19,0H5.81C2.17,0,0,2.17,0,5.81v8.37C0,17.83,2.17,20,5.81,20h8.37c3.64,0,5.81-2.17,5.81-5.81V5.81C20,2.17,17.83,0,14.19,0Zm1.34,5.53L7.81,13.25h3.02a.75.75,0,0,1,0,1.5H6A.755.755,0,0,1,5.25,14V9.17a.75.75,0,0,1,1.5,0v3.02l7.72-7.72a.748.748,0,0,1,1.06,0A.754.754,0,0,1,15.53,5.53Z" transform="translate(238 510)" fill="currentColor" />
        <path id="Vector-2" data-name="Vector" d="M0,0H24V24H0Z" transform="translate(260 532) rotate(180)" fill="none" opacity="0" />
      </g>
    </g>
  </SvgIcon>
);

export const StopCircleFillIcon = (props: SvgIconProps) => (
  <SvgIcon {...props} viewBox="0 0 32 32">
    <g id="vuesax_bold_record-circle" data-name="vuesax/bold/record-circle" transform="translate(-428 -380)">
      <g id="record-circle" transform="translate(428 380)">
        <path id="Vector" d="M13.333,0A13.333,13.333,0,1,0,26.667,13.333,13.338,13.338,0,0,0,13.333,0Zm.04,18.973a5.64,5.64,0,1,1,5.64-5.64A5.633,5.633,0,0,1,13.373,18.973Z" transform="translate(2.627 2.667)" fill="currentColor" />
        <path id="Vector-2" data-name="Vector" d="M0,0H32V32H0Z" fill="none" opacity="0" />
      </g>
    </g>
  </SvgIcon>
);

export const VolumeFillIcon = (props: SvgIconProps) => (
  <SvgIcon {...props} viewBox="0 0 32 32">
    <g id="vuesax_bold_volume-high" data-name="vuesax/bold/volume-high" transform="translate(-684 -188)">
      <g id="volume-high" transform="translate(684 188)">
        <path id="Vector" d="M1,12.667a1.013,1.013,0,0,1-.6-.2,1,1,0,0,1-.2-1.4A7.92,7.92,0,0,0,.2,1.6,1,1,0,1,1,1.8.4a9.961,9.961,0,0,1,0,11.867A.985.985,0,0,1,1,12.667Z" transform="translate(23 9.666)" fill="currentColor" />
        <path id="Vector-2" data-name="Vector" d="M1,19.334a1.013,1.013,0,0,1-.6-.2,1,1,0,0,1-.2-1.4A13.521,13.521,0,0,0,.2,1.6,1,1,0,1,1,1.8.4a15.521,15.521,0,0,1,0,18.533A.967.967,0,0,1,1,19.334Z" transform="translate(25.44 6.333)" fill="currentColor" />
        <path id="Vector-3" data-name="Vector" d="M17.027.5c-1.493-.827-3.4-.613-5.347.6L7.787,3.535a1.727,1.727,0,0,1-.88.253H5c-3.227,0-5,1.773-5,5v5.333c0,3.227,1.773,5,5,5H6.907a1.727,1.727,0,0,1,.88.253l3.893,2.44a6.443,6.443,0,0,0,3.387,1.093,4,4,0,0,0,1.96-.493c1.48-.827,2.307-2.547,2.307-4.84V5.335C19.333,3.042,18.507,1.322,17.027.5Z" transform="translate(1.667 4.545)" fill="currentColor" />
        <path id="Vector-4" data-name="Vector" d="M0,0H32V32H0Z" fill="none" opacity="0" />
      </g>
    </g>
  </SvgIcon>
);

export const VolumeMuteFillIcon = (props: SvgIconProps) => (
  <SvgIcon {...props} viewBox="0 0 24 24" width="24" height="24">
    <g id="vuesax_bold_volume-slash" data-name="vuesax/bold/volume-slash" transform="translate(-428 -188)">
      <g id="volume-slash">
        <path id="Vector" d="M.75,8.078a.76.76,0,0,1-.45-.15.75.75,0,0,1-.15-1.05,5.926,5.926,0,0,0,.72-5.84A.748.748,0,1,1,2.25.458a7.456,7.456,0,0,1-.9,7.33A.758.758,0,0,1,.75,8.078Z" transform="translate(445.25 196.672)" fill="currentColor" />
        <path id="Vector-2" data-name="Vector" d="M.75,12.2a.76.76,0,0,1-.45-.15A.75.75,0,0,1,.15,11a10.129,10.129,0,0,0,1.23-9.96A.748.748,0,0,1,2.76.458,11.618,11.618,0,0,1,1.35,11.9.726.726,0,0,1,.75,12.2Z" transform="translate(447.08 195.052)" fill="currentColor" />
        <path id="Vector-3" data-name="Vector" d="M5.138.294A1,1,0,0,1,6.848,1v2.93a3.9,3.9,0,0,1-1.73,3.63,3,3,0,0,1-1.47.37,4.832,4.832,0,0,1-2.54-.82l-.64-.4a1,1,0,0,1-.18-1.55Z" transform="translate(436.902 200.666)" fill="currentColor" />
        <path id="Vector-4" data-name="Vector" d="M20.52.225a.773.773,0,0,0-1.09,0l-4.95,4.95a3.8,3.8,0,0,0-1.72-3.39,3.911,3.911,0,0,0-4.01.45L5.84,4.055a1.3,1.3,0,0,1-.66.19H3.75A3.381,3.381,0,0,0,0,7.995v4a3.381,3.381,0,0,0,3.75,3.75h.16L.97,18.685a.773.773,0,0,0,0,1.09.834.834,0,0,0,.55.22.758.758,0,0,0,.54-.23L20.52,1.3A.743.743,0,0,0,20.52.225Z" transform="translate(429.25 190.005)" fill="currentColor" />
        <path id="Vector-5" data-name="Vector" d="M0,0H24V24H0Z" transform="translate(428 188)" fill="none" opacity="0" />
      </g>
    </g>
  </SvgIcon>
);

export const FolderFillIcon = (props: SvgIconProps) => (
  <SvgIcon {...props} viewBox="0 0 32 32">
    <g id="vuesax_bold_folder-2" data-name="vuesax/bold/folder-2" transform="translate(-428 -188)">
      <g id="folder-2" transform="translate(428 188)">
        <path id="Vector" d="M9.893,3.533a4.545,4.545,0,0,0-.88-.293,7.158,7.158,0,0,0-2.027-.28H2.253L.52.653A7.973,7.973,0,0,0,0,0H4.507A5.858,5.858,0,0,1,9.893,3.533Z" transform="translate(16.453 2.667)" fill="currentColor" />
        <path id="Vector-2" data-name="Vector" d="M24.187,6.053a5.573,5.573,0,0,0-1.933-.893,5.5,5.5,0,0,0-1.48-.2h-4.96c-.773,0-.827-.067-1.24-.613l-1.867-2.48A3.822,3.822,0,0,0,8.987,0H5.893A5.9,5.9,0,0,0,0,5.893v14.88a5.9,5.9,0,0,0,5.893,5.893h14.88a5.9,5.9,0,0,0,5.893-5.893v-9.92A5.854,5.854,0,0,0,24.187,6.053ZM16.52,19.12H10.133a.933.933,0,0,1,0-1.867H16.52a.933.933,0,1,1,0,1.867Z" transform="translate(2.667 2.667)" fill="currentColor" />
        <path id="Vector-3" data-name="Vector" d="M0,0H32V32H0Z" transform="translate(32 32) rotate(180)" fill="none" opacity="0" />
      </g>
    </g>
  </SvgIcon>
);

export const FolderIcon = (props: SvgIconProps) => (
  <SvgIcon {...props} viewBox="0 0 32 32">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      viewBox="0 0 24 24"
    >
      <path
        d="M21.017 7.992c.398.566-.076 1.258-.769 1.258H3a1 1 0 0 1-1-1V6.42C2 3.98 3.98 2 6.42 2h2.32c1.63 0 2.14.53 2.79 1.4l1.4 1.86c.31.41.35.46.93.46h2.79c1.805 0 3.402.897 4.367 2.272ZM20.983 10.75a1 1 0 0 1 1 .997L22 16.65C22 19.6 19.6 22 16.65 22h-9.3C4.4 22 2 19.6 2 16.65v-4.9a1 1 0 0 1 1-1h17.983Z"
      />
    </svg>
  </SvgIcon>
);

export const FileIcon = (props: SvgIconProps) => (
  <SvgIcon {...props} viewBox="0 0 32 32">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      viewBox="0 0 24 24"
    >
      <path
        d="M16.19 2H7.81C4.17 2 2 4.17 2 7.81v8.37C2 19.83 4.17 22 7.81 22h8.37c3.64 0 5.81-2.17 5.81-5.81V7.81C22 4.17 19.83 2 16.19 2Zm-.44 13.75h-7.5c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h7.5c.41 0 .75.34.75.75s-.34.75-.75.75Zm0-6h-7.5c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h7.5c.41 0 .75.34.75.75s-.34.75-.75.75Z"
      />
    </svg>
  </SvgIcon>
);

export const VideoSpeedFillIcon = (props: SvgIconProps) => (
  <SvgIcon {...props} viewBox="0 0 32 32">
    <g id="speedometer" transform="translate(-492 -572)">
      <path id="Vector" d="M0,0H32V32H0Z" transform="translate(492 572)" fill="none" opacity="0" />
      <path id="Vector-2" data-name="Vector" d="M23.853,24.667a1.033,1.033,0,0,1-.707-.28.994.994,0,0,1-.013-1.413A12.333,12.333,0,1,0,2,14.333a12.244,12.244,0,0,0,3.507,8.613,1,1,0,0,1-1.427,1.4A14.333,14.333,0,1,1,28.667,14.333a14.229,14.229,0,0,1-4.107,10.04A.967.967,0,0,1,23.853,24.667Z" transform="translate(493.667 574.333)" fill="currentColor" />
      <path id="Vector-3" data-name="Vector" d="M10.347,5.173A5.173,5.173,0,1,1,5.173,0,5.173,5.173,0,0,1,10.347,5.173Z" transform="translate(502.827 590.987)" fill="currentColor" />
      <path id="Vector-4" data-name="Vector" d="M2.667,0A2.675,2.675,0,0,0,0,2.667v1A1.667,1.667,0,0,0,1.667,5.333h1A2.667,2.667,0,0,0,2.667,0Z" transform="translate(510.667 583.333)" fill="currentColor" />
    </g>
  </SvgIcon>
);

export const ForwardFillIcon = (props: SvgIconProps) => (
  <SvgIcon {...props} viewBox="0 0 32 32">
    <g id="vuesax_bold_forward" data-name="vuesax/bold/forward" transform="translate(-108 -444)">
      <g id="forward" transform="translate(108 444)">
        <path id="Vector" d="M0,0H32V32H0Z" fill="none" opacity="0" />
        <path id="Vector-2" data-name="Vector" d="M0,2.6v9.76a2.606,2.606,0,0,0,3.907,2.253l4.227-2.44,4.227-2.44.653-.373V5.6l-.653-.373L8.133,2.791,3.907.351A2.606,2.606,0,0,0,0,2.6Z" transform="translate(2.667 8.515)" fill="currentColor" />
        <path id="Vector-3" data-name="Vector" d="M0,2.6v9.76a2.6,2.6,0,0,0,3.893,2.253l4.24-2.44,4.227-2.44a2.613,2.613,0,0,0,0-4.507L8.133,2.791,3.893.351A2.6,2.6,0,0,0,0,2.6Z" transform="translate(15.68 8.515)" fill="currentColor" />
      </g>
    </g>
  </SvgIcon>
);

export const BackwardFillIcon = (props: SvgIconProps) => (
  <SvgIcon {...props} viewBox="0 0 32 32">
    <g id="forward">
      <path id="Vector" d="M32,0H0V32H32Z" fill="none" opacity="0" />
      <path id="Vector-2" data-name="Vector" d="M13.013,2.6v9.76a2.606,2.606,0,0,1-3.907,2.253L4.88,12.178.653,9.738,0,9.365V5.6l.653-.373L4.88,2.791,9.107.351A2.606,2.606,0,0,1,13.013,2.6Z" transform="translate(16.32 8.515)" fill="currentColor" />
      <path id="Vector-3" data-name="Vector" d="M13.65,2.6v9.76a2.6,2.6,0,0,1-3.893,2.253l-4.24-2.44L1.29,9.738a2.613,2.613,0,0,1,0-4.507l4.227-2.44L9.757.351A2.6,2.6,0,0,1,13.65,2.6Z" transform="translate(2.67 8.515)" fill="currentColor" />
    </g>
  </SvgIcon>
);

export const StopCircleIcon = (props: SvgIconProps) => (
  <SvgIcon {...props} viewBox="0 0 32 32">
    <g id="vuesax_bold_stop-circle" data-name="vuesax/bold/stop-circle" transform="translate(-492 -380)">
      <g id="stop-circle" transform="translate(492 380)">
        <path id="Vector" d="M13.333,0A13.333,13.333,0,1,0,26.667,13.333,13.338,13.338,0,0,0,13.333,0Zm5.68,14.973a4,4,0,0,1-4,4h-3.28a4,4,0,0,1-4-4v-3.28a4,4,0,0,1,4-4h3.28a4,4,0,0,1,4,4Z" transform="translate(2.627 2.667)" fill="currentColor" />
        <path id="Vector-2" data-name="Vector" d="M0,0H32V32H0Z" fill="none" opacity="0" />
      </g>
    </g>
  </SvgIcon>
);

export const PauseCircleIcon = (props: SvgIconProps) => (
  <SvgIcon {...props} width="24" height="24" viewBox="0 0 24 24">
    <g id="Group_15477" data-name="Group 15477" transform="translate(-1065 -105)">
      <g id="vuesax_bold_pause-circle" data-name="vuesax/bold/pause-circle" transform="translate(509 -275)">
        <g id="pause-circle">
          <path id="Vector" d="M10,0A10,10,0,1,0,20,10,10,10,0,0,0,10,0ZM8.75,13.03c0,.48-.2.67-.71.67H6.74c-.51,0-.71-.19-.71-.67V6.97c0-.48.2-.67.71-.67H8.03c.51,0,.71.19.71.67v6.06Zm5.28,0c0,.48-.2.67-.71.67H12.03c-.51,0-.71-.19-.71-.67V6.97c0-.48.2-.67.71-.67h1.29c.51,0,.71.19.71.67Z" transform="translate(557.97 382)" fill="currentColor" />
          <path id="Vector-2" data-name="Vector" d="M0,0H24V24H0Z" transform="translate(556 380)" fill="none" opacity="0" />
        </g>
      </g>
    </g>
  </SvgIcon>
);

export const PlayCircleIcon = (props: SvgIconProps) => (
  <SvgIcon {...props} viewBox="0 0 32 32">
    <g id="vuesax_bold_video-circle" data-name="vuesax/bold/video-circle" transform="translate(-300 -252)">
      <g id="video-circle" transform="translate(300 252)">
        <path id="Vector" d="M13.333,0A13.333,13.333,0,1,0,26.667,13.333,13.338,13.338,0,0,0,13.333,0ZM16.88,15.64l-1.707.987-1.707.987c-2.2,1.267-4,.227-4-2.307V11.36c0-2.547,1.8-3.573,4-2.307l1.707.987,1.707.987C19.08,12.293,19.08,14.373,16.88,15.64Z" transform="translate(2.667 2.667)" fill="currentColor" />
        <path id="Vector-2" data-name="Vector" d="M0,0H32V32H0Z" fill="none" opacity="0" />
      </g>
    </g>
  </SvgIcon>
);

export const RepeatFillIcon = (props: SvgIconProps) => (
  <SvgIcon {...props} viewBox="0 0 32 32">
    <path id="Vector" d="M0,0H32V32H0Z" fill="none" opacity="0" />
    <path id="Vector-2" data-name="Vector" d="M3.547,19.909a.989.989,0,0,1-.707-.293A9.683,9.683,0,0,1,9.667,3.082l8.093.027L16.307,1.722A1,1,0,1,1,17.693.282L20.947,3.4a1,1,0,0,1-.693,1.72L9.667,5.1a7.684,7.684,0,0,0-5.413,13.12,1.006,1.006,0,0,1,0,1.413A1.033,1.033,0,0,1,3.547,19.909Z" transform="translate(1.667 2.998)" fill="currentColor" />
    <path id="Vector-3" data-name="Vector" d="M4.255,19.917a1,1,0,0,1-.693-.28L.308,16.517a1.013,1.013,0,0,1-.24-1.093A1,1,0,0,1,1,14.8l10.6.027A7.684,7.684,0,0,0,17.015,1.7,1,1,0,1,1,18.428.29,9.683,9.683,0,0,1,11.6,16.823L3.508,16.8l1.453,1.387A.994.994,0,0,1,4.988,19.6,1.024,1.024,0,0,1,4.255,19.917Z" transform="translate(9.078 9.083)" fill="currentColor" />
    <path id="Vector-4" data-name="Vector" d="M4.667,9.333h8a4.667,4.667,0,0,0,0-9.333h-8a4.667,4.667,0,0,0,0,9.333Z" transform="translate(7.333 11.333)" fill="currentColor" />
  </SvgIcon>
);

export const DoubleArrowRightIcon = (props: SvgIconProps) => (
  <SvgIcon {...props} viewBox="0 0 32 32">
    <g id="Group_15476" data-name="Group 15476" transform="translate(-1022 -8054)">
      <path id="Vector" d="M0,0H32V32H0Z" transform="translate(1054 8086) rotate(180)" fill="none" opacity="0" />
      <g id="Group_15409" data-name="Group 15409" transform="translate(1026 8061)">
        <path id="Vector-2" data-name="Vector" d="M9.209,7.2,6.625,4.62,2.414.409A1.419,1.419,0,0,0,0,1.419V16.952a1.413,1.413,0,0,0,2.414,1l6.8-6.8A2.8,2.8,0,0,0,9.209,7.2Z" transform="translate(0 0)" fill="currentColor" />
        <path id="Vector-3" data-name="Vector" d="M9.209,7.2,6.625,4.62,2.414.409A1.419,1.419,0,0,0,0,1.419V16.952a1.413,1.413,0,0,0,2.414,1l6.8-6.8A2.8,2.8,0,0,0,9.209,7.2Z" transform="translate(13.634 0)" fill="currentColor" />
      </g>
    </g>
  </SvgIcon>
);

export const DoubleArrowLeftIcon = (props: SvgIconProps) => (
  <SvgIcon {...props} viewBox="0 0 32 32">
    <g id="forward">
      <path id="Vector" d="M32,0H0V32H32Z" fill="none" opacity="0" />
      <path id="Vector-2" data-name="Vector" d="M13.013,2.6v9.76a2.606,2.606,0,0,1-3.907,2.253L4.88,12.178.653,9.738,0,9.365V5.6l.653-.373L4.88,2.791,9.107.351A2.606,2.606,0,0,1,13.013,2.6Z" transform="translate(16.32 8.515)" fill="currentColor" />
      <path id="Vector-3" data-name="Vector" d="M13.65,2.6v9.76a2.6,2.6,0,0,1-3.893,2.253l-4.24-2.44L1.29,9.738a2.613,2.613,0,0,1,0-4.507l4.227-2.44L9.757.351A2.6,2.6,0,0,1,13.65,2.6Z" transform="translate(2.67 8.515)" fill="currentColor" />
    </g>
  </SvgIcon>
);

export const LampOnIcon = (props: SvgIconProps) => (
  <SvgIcon {...props} viewBox="0 0 32 32">
    <g id="lamp-on" transform="translate(-492 -188)">
      <path id="Vector" d="M20.32,5.81A10.554,10.554,0,0,0,13.147.263,10.772,10.772,0,0,0,4.013,2.37,10.63,10.63,0,0,0,0,10.73a11.54,11.54,0,0,0,5.187,9.16V21a1.789,1.789,0,0,0,.427,1.413,2.3,2.3,0,0,0,1.707.533h6.84a2.227,2.227,0,0,0,1.64-.573,1.994,1.994,0,0,0,.48-1.547V19.89C20.413,17.1,23.013,11.223,20.32,5.81Z" transform="translate(497.293 190.67)" fill="currentColor" />
      <path id="Vector-2" data-name="Vector" d="M9.611,2.467a.837.837,0,0,1-.253-.04,14.935,14.935,0,0,0-8.173,0,.931.931,0,0,1-1.147-.64A.92.92,0,0,1,.678.64a16.851,16.851,0,0,1,9.2,0,.926.926,0,0,1,.64,1.147A.964.964,0,0,1,9.611,2.467Z" transform="translate(502.735 214.867)" fill="currentColor" />
      <path id="Vector-3" data-name="Vector" d="M0,0H32V32H0Z" transform="translate(524 220) rotate(180)" fill="none" opacity="0" />
    </g>
  </SvgIcon>
);

export const ColorSwatchIcon = (props: SvgIconProps) => (
  <SvgIcon {...props} viewBox="0 0 32 32">
    <g id="color-swatch" transform="translate(-300 -316)">
      <path id="Vector" d="M0,0H32V32H0Z" transform="translate(300 316)" fill="none" opacity="0" />
      <path id="Vector-2" data-name="Vector" d="M14.186,3.333v4a3.335,3.335,0,0,1-3.333,3.333H1.333A1.331,1.331,0,0,1,.386,8.4L8.213.4A1.356,1.356,0,0,1,9.159,0h1.693A3.335,3.335,0,0,1,14.186,3.333Z" transform="translate(315.147 334.667)" fill="currentColor" />
      <path id="Vector-3" data-name="Vector" d="M9.173,8.527,5.56,12.14,2.28,15.407A1.334,1.334,0,0,1,0,14.473V3.153a1.377,1.377,0,0,1,.387-.947L1.613.98a3.332,3.332,0,0,1,4.72,0L9.16,3.807A3.32,3.32,0,0,1,9.173,8.527Z" transform="translate(315.32 322.527)" fill="currentColor" />
      <path id="Vector-4" data-name="Vector" d="M7.333,0h-4A3.149,3.149,0,0,0,0,3.333v18A5.674,5.674,0,0,0,.107,22.4c.04.173.08.347.133.52.067.2.133.4.213.587a.041.041,0,0,1,.013.027c.013,0,.013,0,0,.013a6.723,6.723,0,0,0,.653,1.067c.147.173.293.333.44.493a3.659,3.659,0,0,0,.48.427l.013.013A6.723,6.723,0,0,0,3.12,26.2c.013-.013.013-.013.013,0a4.815,4.815,0,0,0,.613.227c.173.053.347.093.52.133a5.674,5.674,0,0,0,1.067.107,5.184,5.184,0,0,0,1.627-.253c.147-.053.293-.107.44-.173a4.665,4.665,0,0,0,1.32-.8,4.2,4.2,0,0,0,.373-.333l.053-.053a5.343,5.343,0,0,0,1.52-3.72v-18A3.149,3.149,0,0,0,7.333,0Zm-2,23.333a2,2,0,1,1,2-2A2,2,0,0,1,5.333,23.333Z" transform="translate(302.667 318.667)" fill="currentColor" />
    </g>
  </SvgIcon>
);

export const PathIcon = (props: SvgIconProps) => (
  <SvgIcon {...props} viewBox="0 0 32 32">
    <g id="path" transform="translate(-492 -252)">
      <path id="Vector" d="M10.912,10.267,8.085,12.054a1.331,1.331,0,0,1-1.653-.187L.392,5.827A1.331,1.331,0,0,1,.205,4.174L1.992,1.347c1.093-1.72,3.28-1.8,4.893-.2l4.24,4.24A3.127,3.127,0,0,1,10.912,10.267Z" transform="translate(507.781 255.999)" fill="currentColor" />
      <path id="Vector-2" data-name="Vector" d="M15.578,17.876,3.951,19.236a3.674,3.674,0,0,1-2.12-.32L6.6,14.142a1.016,1.016,0,0,0,0-1.48,1.038,1.038,0,0,0-1.48,0L.351,17.436a3.739,3.739,0,0,1-.32-2.107L1.4,3.7C1.751.8,2.818-.164,5.884.022l2,.12A2.681,2.681,0,0,1,9.618.929l8.733,8.733a2.6,2.6,0,0,1,.773,1.733l.12,2C19.551,16.476,18.5,17.542,15.578,17.876Z" transform="translate(496.036 260.724)" fill="currentColor" />
      <path id="Vector-3" data-name="Vector" d="M0,0H32V32H0Z" transform="translate(492 252)" fill="none" opacity="0" />
    </g>
  </SvgIcon>
);

export const BrushIcon = (props: SvgIconProps) => (
  <SvgIcon {...props} viewBox="0 0 32 32">
    <g id="brush" transform="translate(-236 -188)">
      <path id="Vector" d="M16.293,2.584A45.914,45.914,0,0,1,6.76,16.358,7.949,7.949,0,0,0,0,9.744,46.485,46.485,0,0,1,13.84.131a1.9,1.9,0,0,1,2.027.413A1.837,1.837,0,0,1,16.293,2.584Z" transform="translate(248.787 190.669)" fill="currentColor" />
      <path id="Vector-2" data-name="Vector" d="M9.213,6.507c-.267.227-.533.453-.8.667L6.027,9.08c0-.04-.013-.093-.013-.147A6.6,6.6,0,0,0,4.08,5.107,6.705,6.705,0,0,0,.133,3.16C.093,3.16.04,3.147,0,3.147L1.933.707C2.12.467,2.32.24,2.533,0L3.44.12A6.649,6.649,0,0,1,9.067,5.627Z" transform="translate(245.16 201.613)" fill="currentColor" />
      <path id="Vector-3" data-name="Vector" d="M11.271,5.432a5.464,5.464,0,0,1-1.627,3.92A5.352,5.352,0,0,1,6.4,10.9l-3.267.36A2.841,2.841,0,0,1,.018,8.125l.36-3.28A5.436,5.436,0,0,1,5.724.005a5.409,5.409,0,0,1,.8.027A5.462,5.462,0,0,1,9.671,1.605a5.259,5.259,0,0,1,1.547,3.053C11.244,4.925,11.271,5.179,11.271,5.432Z" transform="translate(238.636 206.061)" fill="currentColor" />
      <path id="Vector-4" data-name="Vector" d="M0,0H32V32H0Z" transform="translate(236 188)" fill="none" opacity="0" />
    </g>
  </SvgIcon>
);

export const RotateLeftIcon = (props: SvgIconProps) => (
  <SvgIcon {...props} viewBox="0 0 32 32">
    <g id="rotate-left" transform="translate(-236 -316)">
      <path id="Vector" d="M12.56,25.147A12.563,12.563,0,0,1,2.12,5.6,1,1,0,0,1,3.787,6.707,10.564,10.564,0,1,0,12.56,2.013,12.168,12.168,0,0,0,9,2.533,1,1,0,0,1,8.413.613,14.384,14.384,0,0,1,12.56,0a12.573,12.573,0,0,1,0,25.147Z" transform="translate(239.44 321.187)" fill="currentColor" />
      <path id="Vector-2" data-name="Vector" d="M1,6.424a1.015,1.015,0,0,1-.653-.24A1,1,0,0,1,.244,4.771L4.1.344A1,1,0,0,1,5.511.251,1.008,1.008,0,0,1,5.6,1.664L1.751,6.078A1.01,1.01,0,0,1,1,6.424Z" transform="translate(245.489 317.669)" fill="currentColor" />
      <path id="Vector-3" data-name="Vector" d="M5.5,5.282A1.055,1.055,0,0,1,4.91,5.1L.4,1.8A1,1,0,0,1,1.59.189l4.493,3.28a1,1,0,0,1,.213,1.4A.946.946,0,0,1,5.5,5.282Z" transform="translate(245.49 322.091)" fill="currentColor" />
      <path id="Vector-4" data-name="Vector" d="M0,0H32V32H0Z" transform="translate(236 316)" fill="none" opacity="0" />
    </g>
  </SvgIcon>
);

export const TrashFillIcon = (props: SvgIconProps) => (
  <SvgIcon {...props} viewBox="0 0 32 32">
    <g id="vuesax_bold_trash" data-name="vuesax/bold/trash" transform="translate(-108 -188)">
      <g id="trash" transform="translate(108 188)">
        <path id="Vector" d="M25.1,5.307c-2.147-.213-4.293-.373-6.453-.493V4.8l-.293-1.733C18.151,1.84,17.858,0,14.738,0H11.245c-3.107,0-3.4,1.76-3.613,3.053L7.351,4.76c-1.24.08-2.48.16-3.72.28l-2.72.267A1,1,0,1,0,1.1,7.293l2.72-.267a106.3,106.3,0,0,1,21.093.28h.107a1.01,1.01,0,0,0,1-.907A1.022,1.022,0,0,0,25.1,5.307Z" transform="translate(2.995 1.667)" fill="currentColor" />
        <path id="Vector-2" data-name="Vector" d="M19.736.52A1.686,1.686,0,0,0,18.523,0H1.669A1.663,1.663,0,0,0,.456.52,1.717,1.717,0,0,0,0,1.773l.827,13.68c.147,2.027.333,4.56,4.987,4.56h8.56c4.653,0,4.84-2.52,4.987-4.56l.827-13.667A1.729,1.729,0,0,0,19.736.52ZM12.309,13.333H7.869a1,1,0,1,1,0-2h4.44a1,1,0,0,1,0,2ZM13.429,8H6.763a1,1,0,0,1,0-2h6.667a1,1,0,1,1,0,2Z" transform="translate(5.904 10.333)" fill="currentColor" />
        <path id="Vector-3" data-name="Vector" d="M0,0H32V32H0Z" transform="translate(32 32) rotate(180)" fill="none" opacity="0" />
      </g>
    </g>
  </SvgIcon>
);

export const SplitScannerIcon = (props: SvgIconProps) => (
  <SvgIcon {...props} viewBox="0 0 24 24">
    <g id="vuesax_bold_scanner" data-name="vuesax/bold/scanner" transform="translate(276 -684) rotate(90)">
      <g id="scanner">
        <path id="Vector" d="M0,0H24V24H0Z" transform="translate(684 252)" fill="none" opacity="0" />
        <path id="Vector-2" data-name="Vector" d="M20.75,8.5A.755.755,0,0,1,20,7.75v-2A3.984,3.984,0,0,0,15.75,1.5h-10A3.984,3.984,0,0,0,1.5,5.75v2a.755.755,0,0,1-.75.75A.755.755,0,0,1,0,7.75v-2A5.443,5.443,0,0,1,5.75,0h10A5.443,5.443,0,0,1,21.5,5.75v2A.755.755,0,0,1,20.75,8.5Z" transform="translate(685.25 253.25)" fill="currentColor" />
        <path id="Vector-3" data-name="Vector" d="M15.75,8.5h-10A5.443,5.443,0,0,1,0,2.75v-2A.755.755,0,0,1,.75,0,.755.755,0,0,1,1.5.75v2A3.984,3.984,0,0,0,5.75,7h10A3.984,3.984,0,0,0,20,2.75v-2a.75.75,0,0,1,1.5,0v2A5.443,5.443,0,0,1,15.75,8.5Z" transform="translate(685.25 266.25)" fill="currentColor" />
        <path id="Vector-4" data-name="Vector" d="M20.75,1.5H.75A.755.755,0,0,1,0,.75.755.755,0,0,1,.75,0h20a.755.755,0,0,1,.75.75A.755.755,0,0,1,20.75,1.5Z" transform="translate(685.25 263.25)" fill="currentColor" />
        <path id="Vector-5" data-name="Vector" d="M9.5,4H.5A.5.5,0,0,1,0,3.5v-2A1.5,1.5,0,0,1,1.5,0h7A1.5,1.5,0,0,1,10,1.5v2A.5.5,0,0,1,9.5,4Z" transform="translate(691 257)" fill="currentColor" />
        <path id="Vector-6" data-name="Vector" d="M9.5,0H.5A.5.5,0,0,0,0,.5v2A1.5,1.5,0,0,0,1.5,4h7A1.5,1.5,0,0,0,10,2.5V.5A.5.5,0,0,0,9.5,0Z" transform="translate(691 267)" fill="currentColor" />
      </g>
    </g>
  </SvgIcon>
);

export const RectangleFillIcon = (props: SvgIconProps) => (
  <SvgIcon {...props} viewBox="0 0 20 20">
    <rect id="Rectangle_7449" data-name="Rectangle 7449" width="20" height="20" fill="currentColor" />
  </SvgIcon>
);

export const RectangleOutlineIcon = (props: SvgIconProps) => (
  <SvgIcon {...props} viewBox="0 0 24 24">
    <path id="Vector" d="M0,0H24V24H0Z" transform="translate(24 24) rotate(180)" fill="none" opacity="0" />
    <g id="Rectangle_7448" data-name="Rectangle 7448" transform="translate(2 2)" fill="none" stroke="currentColor" strokeWidth="1">
      <rect width="20" height="20" stroke="none" />
      <rect x="0.5" y="0.5" width="19" height="19" fill="none" />
    </g>
  </SvgIcon>
);

export const CircleFillIcon = (props: SvgIconProps) => (
  <SvgIcon {...props} viewBox="0 0 24 24">
    <path id="Vector" d="M0,0H24V24H0Z" transform="translate(24 24) rotate(180)" fill="none" opacity="0" />
    <circle id="Ellipse_708" data-name="Ellipse 708" cx="10" cy="10" r="10" transform="translate(2 2)" fill="currentColor" />
  </SvgIcon>
);

export const CircleOutlineIcon = (props: SvgIconProps) => (
  <SvgIcon {...props} viewBox="0 0 24 24">
    <g id="Vector" transform="translate(24 24) rotate(180)" fill="#fff" opacity="0">
      <path d="M 23.5 23.5 L 0.5 23.5 L 0.5 0.5 L 23.5 0.5 L 23.5 23.5 Z" stroke="none" />
      <path d="M 1 1 L 1 23 L 23 23 L 23 1 L 1 1 M 0 0 L 24 0 L 24 24 L 0 24 L 0 0 Z" stroke="none" fill="currentColor" />
    </g>
    <g id="Ellipse_707" data-name="Ellipse 707" transform="translate(2 2)" fill="none" stroke="currentColor" strokeWidth="1">
      <circle cx="10" cy="10" r="10" stroke="none" />
      <circle cx="10" cy="10" r="9.5" fill="none" />
    </g>
  </SvgIcon>
);

export const AngleIcon = (props: SvgIconProps) => (
  <SvgIcon {...props} viewBox="0 0 24 24">
    <g id="aave-_aave_" data-name="aave-(aave)">
      <path id="BG_153" data-name="BG 153" d="M0,0H24V24H0Z" fill="none" />
      <path id="Vector" d="M10,0A10,10,0,1,0,20,10,10,10,0,0,0,10,0Zm4.3,14.69a.8.8,0,0,1-.3.06.763.763,0,0,1-.69-.45L10,6.85,8.93,9.25H10a.75.75,0,0,1,0,1.5H8.27L6.69,14.3a.75.75,0,0,1-1.37-.61l1.31-2.95H6a.75.75,0,0,1,0-1.5H7.29L9.31,4.69a.782.782,0,0,1,1.37,0l4,9A.758.758,0,0,1,14.3,14.69Z" transform="translate(2 2)" fill="currentColor" />
      <path id="Vector-2" data-name="Vector" d="M0,0H24V24H0Z" fill="none" opacity="0" />
    </g>
  </SvgIcon>
);

export const LineIcon = (props: SvgIconProps) => (
  <SvgIcon {...props} viewBox="0 0 24 24">
    <path id="Vector" d="M0,0H24V24H0Z" transform="translate(24 24) rotate(180)" fill="none" opacity="0" />
    <line id="Line_1027" data-name="Line 1027" y1="14" x2="14" transform="translate(5 5)" fill="none" stroke="currentColor" strokeLinecap="round" strokeWidth="2" />
  </SvgIcon>
);

export const ArrowIcon = (props: SvgIconProps) => (
  <SvgIcon {...props} viewBox="0 0 24 24">
    <g id="export" transform="translate(0 0)">
      <path id="Vector" d="M14.193,0H5.811C2.17,0,0,2.17,0,5.811v8.372C0,17.833,2.17,20,5.811,20h8.372c3.641,0,5.811-2.17,5.811-5.811V5.811C20,2.17,17.833,0,14.193,0Zm1.06,10.332a.75.75,0,0,1-1.5,0V7.311L6.031,15.033a.749.749,0,0,1-1.06,0,.755.755,0,0,1,0-1.06l7.721-7.721H9.672a.75.75,0,1,1,0-1.5H14.5a.756.756,0,0,1,.75.75Z" transform="translate(1.998 1.998)" fill="currentColor" />
      <path id="Vector-2" data-name="Vector" d="M0,0H24V24H0Z" transform="translate(24 24) rotate(180)" fill="none" opacity="0" />
    </g>
  </SvgIcon>
);

export const PencilIcon = (props: SvgIconProps) => (
  <SvgIcon {...props} viewBox="0 0 24 24">
    <g id="Group_15412" data-name="Group 15412" transform="translate(3.46 3.46)">
      <path id="Vector" d="M7.6,1.566C5.54-.5,3.522-.548,1.408,1.566L.123,2.851a.443.443,0,0,0-.106.425A8.634,8.634,0,0,0,5.89,9.15a.533.533,0,0,0,.127.021.425.425,0,0,0,.308-.127L7.6,7.758a4.39,4.39,0,0,0,1.561-3.07A4.373,4.373,0,0,0,7.6,1.566Z" transform="translate(8.914 0)" fill="currentColor" />
      <path id="Vector-2" data-name="Vector" d="M12.87,5.821c-.308-.149-.605-.3-.892-.467-.234-.138-.457-.287-.68-.446a6.414,6.414,0,0,1-.595-.457,1.3,1.3,0,0,1-.181-.159,8.984,8.984,0,0,1-1.094-1.1A1.294,1.294,0,0,1,9.269,3a6.178,6.178,0,0,1-.446-.584,5.833,5.833,0,0,1-.414-.627c-.17-.287-.319-.574-.467-.871C7.793.595,7.676.287,7.57,0L.9,6.671a1.279,1.279,0,0,0-.3.584L.028,11.323A2.177,2.177,0,0,0,.57,13.182a2.114,2.114,0,0,0,1.487.574,2.322,2.322,0,0,0,.382-.032l4.079-.574a1.182,1.182,0,0,0,.584-.3l6.671-6.671C13.475,6.076,13.189,5.959,12.87,5.821Z" transform="translate(0 4.318)" fill="currentColor" />
    </g>
    <path id="Vector-3" data-name="Vector" d="M0,0H24V24H0Z" transform="translate(24 24) rotate(180)" fill="none" opacity="0" />
  </SvgIcon>
);

export const RecIcon = (props: SvgIconProps) => (
  <SvgIcon {...props} viewBox="0 0 32 32">
    <g id="vuesax_bold_record-circle" data-name="vuesax/bold/record-circle" transform="translate(-428 -380)">
      <g id="record-circle" transform="translate(428 380)">
        <path id="Vector" d="M13.333,0A13.333,13.333,0,1,0,26.667,13.333,13.338,13.338,0,0,0,13.333,0Zm.04,18.973a5.64,5.64,0,1,1,5.64-5.64A5.633,5.633,0,0,1,13.373,18.973Z" transform="translate(2.627 2.667)" fill="currentColor" />
        <path id="Vector-2" data-name="Vector" d="M0,0H32V32H0Z" fill="none" opacity="0" />
      </g>
    </g>
  </SvgIcon>
);

export const AttachIcon = (props: SvgIconProps) => (
  <SvgIcon {...props} viewBox="0 0 24 24">
    <g id="vuesax_linear_paperclip" data-name="vuesax/linear/paperclip" transform="translate(-620 -188)">
      <g id="paperclip" transform="translate(620 188)">
        <path id="Vector" d="M6.333,8.143V11.31a3.167,3.167,0,1,0,6.333,0V6.333A6.333,6.333,0,1,0,0,6.333v5.429A5.433,5.433,0,0,0,5.429,17.19" transform="translate(5.64 3.667)" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" />
        <path id="Vector-2" data-name="Vector" d="M0,0H24V24H0Z" transform="translate(24 24) rotate(180)" fill="none" opacity="0" />
      </g>
    </g>
  </SvgIcon>
);

export const SendIcon = (props: SvgIconProps) => (
  <SvgIcon {...props} viewBox="0 0 24 24">
    <g id="send-2">
      <path id="Vector" d="M13.582.4l-9.03,3c-6.07,2.03-6.07,5.34,0,7.36l2.68.89.89,2.68c2.02,6.07,5.34,6.07,7.36,0l3.01-9.02C19.833,1.257,17.632-.953,13.582.4Zm.32,5.38L10.1,9.6a.748.748,0,0,1-1.06,0,.754.754,0,0,1,0-1.06l3.8-3.82a.75.75,0,0,1,1.06,1.06Z" transform="translate(2.557 2.563)" fill="currentColor" />
      <path id="Vector-2" data-name="Vector" d="M0,0H24V24H0Z" transform="translate(24 24) rotate(180)" fill="none" opacity="0" />
    </g>
  </SvgIcon>
);

export const ExportIcon = (props: SvgIconProps) => (
  <SvgIcon {...props} viewBox="0 0 24 24">
    <g id="export">
      <path id="Vector" d="M19.14,0H10.75V5.48a.75.75,0,0,1-1.5,0V0H.86A.854.854,0,0,0,0,.86a9.565,9.565,0,0,0,10,10,9.565,9.565,0,0,0,10-10A.854.854,0,0,0,19.14,0Z" transform="translate(2 9.9)" fill="currentColor" />
      <path id="Vector-2" data-name="Vector" d="M4.35,2.558l1.56,1.56a.75.75,0,0,0,1.06-1.06L4.12.218a.754.754,0,0,0-1.06,0L.22,3.068A.786.786,0,0,0,0,3.6a.742.742,0,0,0,.22.53.754.754,0,0,0,1.06,0l1.56-1.56v4.09h1.5v-4.1Z" transform="translate(8.4 3.242)" fill="currentColor" />
      <path id="Vector-3" data-name="Vector" d="M0,0H24V24H0Z" transform="translate(24 24) rotate(180)" fill="none" opacity="0" />
    </g>
  </SvgIcon>
);

export const VideoPlayIcon = (props: SvgIconProps) => (
  <SvgIcon {...props} viewBox="0 0 32 32">
    <g id="vuesax_bold_video-circle" data-name="vuesax/bold/video-circle" transform="translate(-300 -252)">
      <g id="video-circle" transform="translate(300 252)">
        <path id="Vector" d="M13.333,0A13.333,13.333,0,1,0,26.667,13.333,13.338,13.338,0,0,0,13.333,0ZM16.88,15.64l-1.707.987-1.707.987c-2.2,1.267-4,.227-4-2.307V11.36c0-2.547,1.8-3.573,4-2.307l1.707.987,1.707.987C19.08,12.293,19.08,14.373,16.88,15.64Z" transform="translate(2.667 2.667)" fill="currentColor" />
        <path id="Vector-2" data-name="Vector" d="M0,0H32V32H0Z" fill="none" opacity="0" />
      </g>
    </g>
  </SvgIcon>
);

export const ProfileUserIcon = (props: SvgIconProps) => (
  <SvgIcon {...props} viewBox="0 0 32 32">
    <g id="vuesax_bold_profile-2user" data-name="vuesax/bold/profile-2user" transform="translate(-282 -125)">
      <g id="profile-2user" transform="translate(282 125)">
        <path id="Vector" d="M6.333,0a6.328,6.328,0,0,0-.16,12.653,1.076,1.076,0,0,1,.293,0H6.56A6.329,6.329,0,0,0,6.333,0Z" transform="translate(5.667 2.667)" fill="currentColor" />
        <path id="Vector-2" data-name="Vector" d="M16.16,1.86a13.239,13.239,0,0,0-13.533,0A5.263,5.263,0,0,0,0,6.167a5.219,5.219,0,0,0,2.613,4.28,12.319,12.319,0,0,0,6.773,1.88,12.319,12.319,0,0,0,6.773-1.88A5.261,5.261,0,0,0,18.773,6.14,5.25,5.25,0,0,0,16.16,1.86Z" transform="translate(2.613 17.007)" fill="currentColor" />
        <path id="Vector-3" data-name="Vector" d="M7.84,4.378a4.772,4.772,0,0,1-4.173,5.16H3.6a.624.624,0,0,0-.227.027A4.784,4.784,0,0,1,0,8.458,6.1,6.1,0,0,0,2,3.391,6.188,6.188,0,0,0,.973.485,4.787,4.787,0,0,1,7.84,4.378Z" transform="translate(18.813 5.409)" fill="currentColor" />
        <path id="Vector-4" data-name="Vector" d="M10.667,5.454a4.061,4.061,0,0,1-2.32,3.173,9.411,9.411,0,0,1-4.68,1.04A4.759,4.759,0,0,0,5.293,6.574,5.253,5.253,0,0,0,3.067,2.067,11.007,11.007,0,0,0,0,.387a10.421,10.421,0,0,1,8.933,1.56A4.051,4.051,0,0,1,10.667,5.454Z" transform="translate(18.653 16.666)" fill="currentColor" />
        <path id="Vector-5" data-name="Vector" d="M0,0H32V32H0Z" transform="translate(32 32) rotate(180)" fill="none" opacity="0" />
      </g>
    </g>
  </SvgIcon>
);

export const BookIcon = (props: SvgIconProps) => (
  <SvgIcon {...props} viewBox="0 0 20 20">
    <path id="Vector" d="M7.708,1.808v9.908a1.713,1.713,0,0,1-1.467,1.65l-.258.033a21.339,21.339,0,0,0-4.842,1.4A.831.831,0,0,1,0,14.025V2.433a.85.85,0,0,1,.45-.742A15.991,15.991,0,0,1,5.85,0H5.9A1.807,1.807,0,0,1,7.708,1.808Z" transform="translate(10.625 2.233)" fill="currentColor" />
    <path id="Vector-2" data-name="Vector" d="M7.267,1.692A15.991,15.991,0,0,0,1.867,0H1.808A1.807,1.807,0,0,0,0,1.808v9.908a1.713,1.713,0,0,0,1.467,1.65l.258.033a21.339,21.339,0,0,1,4.842,1.4.831.831,0,0,0,1.142-.775V2.433A.833.833,0,0,0,7.267,1.692ZM2.508,4.217H4.383a.625.625,0,0,1,0,1.25H2.508a.625.625,0,0,1,0-1.25Zm2.5,3.75h-2.5a.625.625,0,0,1,0-1.25h2.5a.625.625,0,0,1,0,1.25Z" transform="translate(1.658 2.233)" fill="currentColor" />
    <path id="Vector-3" data-name="Vector" d="M0,0H20V20H0Z" transform="translate(20 20) rotate(180)" fill="none" opacity="0" />
  </SvgIcon>
);

export const SecuritySafeIcon = (props: SvgIconProps) => (
  <SvgIcon {...props} viewBox="0 0 16 16">
    <g id="vuesax_bold_security-safe" data-name="vuesax/bold/security-safe" transform="translate(-364 -316)">
      <g id="security-safe" transform="translate(364 316)">
        <path id="Vector" d="M0,0H16V16H0Z" transform="translate(16 16) rotate(180)" fill="none" opacity="0" />
        <path id="Vector-2" data-name="Vector" d="M11.88,6.075V3.148a1.6,1.6,0,0,0-.927-1.373L7.24.255a3.458,3.458,0,0,0-2.607,0L.92,1.775A1.607,1.607,0,0,0,0,3.148V6.075a7.683,7.683,0,0,0,5.6,7.207,1.307,1.307,0,0,0,.68,0A7.683,7.683,0,0,0,11.88,6.075ZM6.44,7.242V8.995a.5.5,0,1,1-1,0V7.242a1.667,1.667,0,1,1,1,0Z" transform="translate(2.06 1.338)" fill="currentColor" />
      </g>
    </g>
  </SvgIcon>
);

export const LocationIcon = (props: SvgIconProps) => (
  <SvgIcon {...props} viewBox="0 0 16 16">
    <g id="vuesax_bold_location" data-name="vuesax/bold/location" transform="translate(-428 -188)">
      <path id="Vector" d="M11.667,4.467A5.75,5.75,0,0,0,5.92,0H5.913A5.749,5.749,0,0,0,.167,4.46C-.613,7.9,1.493,10.813,3.4,12.647a3.615,3.615,0,0,0,5.033,0C10.34,10.813,12.447,7.907,11.667,4.467ZM5.92,7.807a2.1,2.1,0,1,1,2.1-2.1A2.1,2.1,0,0,1,5.92,7.807Z" transform="translate(430.08 189.167)" fill="currentColor" />
      <path id="Vector-2" data-name="Vector" d="M0,0H16V16H0Z" transform="translate(428 188)" fill="none" opacity="0" />
      <path id="Vector-3" data-name="Vector" d="M0,0H16V16H0Z" transform="translate(444 204) rotate(180)" fill="none" opacity="0" />
    </g>
  </SvgIcon>
);

export const BankIcon = (props: SvgIconProps) => (
  <SvgIcon {...props} viewBox="0 0 16 16">
    <g id="vuesax_bold_bank" data-name="vuesax/bold/bank" transform="translate(-428 -188)">
      <g id="bank" transform="translate(428 188)">
        <path id="Vector" d="M0,0H16V16H0Z" fill="none" opacity="0" />
        <path id="Vector-2" data-name="Vector" d="M13.333.667v2H0v-2A.669.669,0,0,1,.667,0h12A.669.669,0,0,1,13.333.667Z" transform="translate(1.333 12)" fill="currentColor" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" />
        <path id="Vector-3" data-name="Vector" d="M0,0H1.333V4.667H0Z" transform="translate(3.333 7.333)" fill="currentColor" />
        <path id="Vector-4" data-name="Vector" d="M0,0H1.333V4.667H0Z" transform="translate(6 7.333)" fill="currentColor" />
        <path id="Vector-5" data-name="Vector" d="M0,0H1.333V4.667H0Z" transform="translate(8.667 7.333)" fill="currentColor" />
        <path id="Vector-6" data-name="Vector" d="M0,0H1.333V4.667H0Z" transform="translate(11.333 7.333)" fill="currentColor" />
        <path id="Vector-7" data-name="Vector" d="M15.167,1H.5A.5.5,0,0,1,0,.5.5.5,0,0,1,.5,0H15.167a.5.5,0,0,1,.5.5A.5.5,0,0,1,15.167,1Z" transform="translate(0.167 14.167)" fill="currentColor" />
        <path id="Vector-8" data-name="Vector" d="M12.913,2.44l-6-2.4a.781.781,0,0,0-.493,0l-6,2.4A.714.714,0,0,0,0,3.06V5.273a.669.669,0,0,0,.667.667h12a.669.669,0,0,0,.667-.667V3.06A.714.714,0,0,0,12.913,2.44ZM6.667,4.273a1,1,0,1,1,1-1A1,1,0,0,1,6.667,4.273Z" transform="translate(1.333 1.393)" fill="currentColor" />
      </g>
    </g>
  </SvgIcon>
);

export const AccountIcon = (props: SvgIconProps) => (
  <SvgIcon {...props} viewBox="0 0 16 16">
    <g id="Group_12661" data-name="Group 12661" transform="translate(-860 -264)">
      <g id="vuesax_bold_frame" data-name="vuesax/bold/frame" transform="translate(752 12)">
        <g id="frame" transform="translate(108 252)">
          <path id="Vector" d="M3.167,0a3.164,3.164,0,0,0-.08,6.327.538.538,0,0,1,.147,0H3.28A3.164,3.164,0,0,0,3.167,0Z" transform="translate(4.833 1.333)" fill="currentColor" />
          <path id="Vector-2" data-name="Vector" d="M8.08.93a6.619,6.619,0,0,0-6.767,0A2.631,2.631,0,0,0,0,3.083a2.609,2.609,0,0,0,1.307,2.14,6.16,6.16,0,0,0,3.387.94,6.16,6.16,0,0,0,3.387-.94A2.63,2.63,0,0,0,9.387,3.07,2.625,2.625,0,0,0,8.08.93Z" transform="translate(3.307 8.503)" fill="currentColor" />
          <path id="Vector-3" data-name="Vector" d="M0,0H16V16H0Z" transform="translate(16 16) rotate(180)" fill="none" opacity="0" />
        </g>
      </g>
    </g>
  </SvgIcon>
);

export const DocumentPlaceHolder = ({ width, height, ...props }: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} {...props}>
    <g fillRule="nonzero" fill="none">
      <path d="M6 0h172a6 6 0 0 1 6 6v118H0V6a6 6 0 0 1 6-6Z" fill="#FFF" />
      <path
        fill="#F3F3F8"
        d="M16 16h50v6H16zM16 30h127v6H16zM16 58h52v6H16zM16 100h85v6H16zM16 86h31v6H16zM16 44h48v6H16zM16 72h52v6H16z"
      />
      <path
        d="M111.297 43.269v34.737H74.504V50.783L84.194 41h24.926a2.261 2.261 0 0 1 2.177 2.269Z"
        fill="#EFF2F3"
      />
      <path
        d="M82.231 50.783h-7.656L84.287 41l-.071 7.656a1.975 1.975 0 0 1-1.985 2.127Z"
        fill="#DADEDE"
      />
      <path
        d="M96.481 60.85a28.236 28.236 0 0 1-3.511-4.254c.562-.851 1.9-5.742-.14-7.16-2.04-1.418-3.09 1.205-3.09 1.205a8.022 8.022 0 0 0 1.264 6.239l-2.457 5.459c-.281 0-8.075 3.048-5.407 6.806 2.738 3.757 6.53-5.317 6.53-5.317a55.918 55.918 0 0 1 5.968-1.134 9.386 9.386 0 0 0 3.862 3.19c3.23.851 3.581-1.843 3.581-1.843.071-3.545-6.6-3.191-6.6-3.191Zm-12.007 7.018a.069.069 0 0 1-.07-.071c-.421-.992 2.809-2.907 2.809-2.907s-1.756 3.404-2.739 2.978Zm7.303-17.159c.913.851.14 3.757.14 3.757s-1.053-2.903-.14-3.757Zm-.844 10.992 1.264-3.119 1.966 2.41-3.23.709Zm10.393 2.268c-.562.922-2.879-1.063-3.09-1.276.351 0 3.37.213 3.09 1.276Zm9.971 11.768v8.365a2.274 2.274 0 0 1-2.247 2.269H76.68a2.273 2.273 0 0 1-2.247-2.268v-8.366h36.864Z"
        fill="#F2786B"
      />
      <path
        d="M89.99 79.424c.008.509-.198.997-.567 1.347a2.634 2.634 0 0 1-1.631.425h-.567v2.056h-.921v-5.459h1.631a2.409 2.409 0 0 1 1.56.425c.357.293.543.746.495 1.206Zm-2.694 1.063h.5c.344.021.687-.052.992-.213a.915.915 0 0 0 .354-.78.822.822 0 0 0-.284-.709 1.609 1.609 0 0 0-.922-.213h-.638l-.002 1.915Zm8.294 0a2.616 2.616 0 0 1-.78 2.056c-.605.527-1.4.784-2.2.709h-1.556v-5.459h1.7a2.8 2.8 0 0 1 2.056.709c.537.516.822 1.241.781 1.985h-.001Zm-.992 0c0-1.347-.638-1.985-1.843-1.985h-.78v3.97h.638c1.347.071 1.985-.638 1.985-1.985Zm3.048 2.765h-.922v-5.459h3.12v.78h-2.2v1.7h2.06v.78h-2.057l-.001 2.199Z"
        fill="#EFF2F3"
      />
    </g>
  </svg>
);

export const BoldExpandMoreIcon = (props: SvgIconProps) => (
  <SvgIcon width="31" height="7" viewBox="0 0 31 7" {...props}>
    <g
      id="Group_1"
      data-name="Group 1"
      transform="translate(31 6.736) rotate(180)"
    >
      <g id="Group_15197" data-name="Group 15197">
        <circle
          id="Ellipse_350"
          data-name="Ellipse 350"
          cx="3.5"
          cy="3.5"
          r="3.5"
          transform="translate(24 -0.264)"
        />
        <circle
          id="Ellipse_349"
          data-name="Ellipse 349"
          cx="3.5"
          cy="3.5"
          r="3.5"
          transform="translate(12 -0.264)"
        />
        <circle
          id="Ellipse_348"
          data-name="Ellipse 348"
          cx="3.5"
          cy="3.5"
          r="3.5"
          transform="translate(0 -0.264)"
        />
      </g>
    </g>
  </SvgIcon>
);

export const BoldPlayIcon = (props: SvgIconProps) => (
  <SvgIcon width="32" height="32" viewBox="0 0 32 32" {...props}>
    <g
      id="vuesax_bold_video-circle"
      data-name="vuesax/bold/video-circle"
      transform="translate(-300 -252)"
    >
      <g id="video-circle" transform="translate(300 252)">
        <path
          id="Vector"
          d="M13.333,0A13.333,13.333,0,1,0,26.667,13.333,13.338,13.338,0,0,0,13.333,0ZM16.88,15.64l-1.707.987-1.707.987c-2.2,1.267-4,.227-4-2.307V11.36c0-2.547,1.8-3.573,4-2.307l1.707.987,1.707.987C19.08,12.293,19.08,14.373,16.88,15.64Z"
          transform="translate(2.667 2.667)"
        />
        <path
          id="Vector-2"
          data-name="Vector"
          d="M0,0H32V32H0Z"
          fill="none"
          opacity="0"
        />
      </g>
    </g>
  </SvgIcon>
);

export const BoldFolderIcon = (props: SvgIconProps) => (
  <SvgIcon width="32" height="32" viewBox="0 0 32 32" {...props}>
    <g
      id="vuesax_bold_folder-2"
      data-name="vuesax/bold/folder-2"
      transform="translate(-428 -188)"
    >
      <g id="folder-2" transform="translate(428 188)">
        <path
          id="Vector"
          d="M9.893,3.533a4.545,4.545,0,0,0-.88-.293,7.158,7.158,0,0,0-2.027-.28H2.253L.52.653A7.973,7.973,0,0,0,0,0H4.507A5.858,5.858,0,0,1,9.893,3.533Z"
          transform="translate(16.453 2.667)"
        />
        <path
          id="Vector-2"
          data-name="Vector"
          d="M24.187,6.053a5.573,5.573,0,0,0-1.933-.893,5.5,5.5,0,0,0-1.48-.2h-4.96c-.773,0-.827-.067-1.24-.613l-1.867-2.48A3.822,3.822,0,0,0,8.987,0H5.893A5.9,5.9,0,0,0,0,5.893v14.88a5.9,5.9,0,0,0,5.893,5.893h14.88a5.9,5.9,0,0,0,5.893-5.893v-9.92A5.854,5.854,0,0,0,24.187,6.053ZM16.52,19.12H10.133a.933.933,0,0,1,0-1.867H16.52a.933.933,0,1,1,0,1.867Z"
          transform="translate(2.667 2.667)"
        />
        <path
          id="Vector-3"
          data-name="Vector"
          d="M0,0H32V32H0Z"
          transform="translate(32 32) rotate(180)"
          fill="none"
          opacity="0"
        />
      </g>
    </g>
  </SvgIcon>
);

export const BoldAudioIcon = (props: SvgIconProps) => (
  <SvgIcon width="24" height="24" viewBox="0 0 24 24" {...props}>
    <g
      id="Group_16327"
      data-name="Group 16327"
      transform="translate(-291.494 -13.494)"
    >
      <g
        id="vuesax_bold_note-square"
        data-name="vuesax/bold/note-square"
        transform="translate(-136.506 -558.506)"
      >
        <g id="note-square">
          <path
            id="Vector"
            d="M0,0H24V24H0Z"
            transform="translate(428 572)"
            fill="none"
            opacity="0"
          />
          <path
            id="Vector-2"
            data-name="Vector"
            d="M8.74.865,8.12.655,6.45.1A1.8,1.8,0,0,0,4.83.3a1.809,1.809,0,0,0-.7,1.48V6.57a2.765,2.765,0,0,0-1.34-.36A2.8,2.8,0,0,0,0,9.015a3.083,3.083,0,0,0,.1.75,2.8,2.8,0,0,0,5.49-.69V4.465c.02,0,.03.01.05.02l2.28.76a.611.611,0,0,0,.13.03,1.842,1.842,0,0,0,.51.07,1.612,1.612,0,0,0,.98-.31,1.749,1.749,0,0,0,.7-1.47v-.6a2.293,2.293,0,0,0-1.5-2.1Zm-5.95,9.49a1.312,1.312,0,0,1-1.1-.59,1.282,1.282,0,0,1-.23-.75,1.335,1.335,0,1,1,2.67,0,1.27,1.27,0,0,1-.16.62,1.326,1.326,0,0,1-1.18.72Z"
            transform="translate(440.88 583.235)"
          />
          <path
            id="Vector-3"
            data-name="Vector"
            d="M10.24,2.965v.6a1.749,1.749,0,0,1-.7,1.47,1.612,1.612,0,0,1-.98.31,1.842,1.842,0,0,1-.51-.07.611.611,0,0,1-.13-.03l-2.28-.76c-.02-.01-.03-.02-.05-.02v4.61a2.8,2.8,0,0,1-5.49.69,3.083,3.083,0,0,1-.1-.75,2.8,2.8,0,0,1,2.79-2.8,2.765,2.765,0,0,1,1.34.36V1.785A1.809,1.809,0,0,1,4.83.3,1.8,1.8,0,0,1,6.45.1L8.12.65l.62.21A2.293,2.293,0,0,1,10.24,2.965Z"
            transform="translate(440.88 583.235)"
          />
          <path
            id="Vector-4"
            data-name="Vector"
            d="M19,5.52v2.1a.5.5,0,0,1-.66.47l-.54-.18a3.2,3.2,0,0,0-4.29,3.11v2.45a.547.547,0,0,1-.48.53,4.306,4.306,0,0,0-3.65,4.25v.15a.565.565,0,0,1-.54.6H5.52C2.07,19,0,16.94,0,13.48V5.52C0,2.06,2.07,0,5.52,0h7.96C16.93,0,19,2.06,19,5.52Z"
            transform="translate(430 574)"
          />
        </g>
      </g>
    </g>
  </SvgIcon>
);

export const BoldSettingIcon = (props: SvgIconProps) => (
  <SvgIcon width="20" height="20" viewBox="0 0 20 20" {...props}>
    <g
      id="vuesax_bold_setting-4"
      data-name="vuesax/bold/setting-4"
      transform="translate(-428 -190)"
    >
      <g id="setting-4" transform="translate(428 190)">
        <path
          id="Vector"
          d="M5.233,1.167H.583A.58.58,0,0,1,0,.583.58.58,0,0,1,.583,0h4.65a.58.58,0,0,1,.583.583A.58.58,0,0,1,5.233,1.167Z"
          transform="translate(12.517 5.15)"
        />
        <path
          id="Vector-2"
          data-name="Vector"
          d="M3.683,1.167H.583A.58.58,0,0,1,0,.583.58.58,0,0,1,.583,0h3.1a.583.583,0,0,1,0,1.167Z"
          transform="translate(1.667 5.15)"
        />
        <path
          id="Vector-3"
          data-name="Vector"
          d="M6.583,3.292A3.292,3.292,0,1,1,3.292,0,3.292,3.292,0,0,1,6.583,3.292Z"
          transform="translate(5.158 2.442)"
        />
        <path
          id="Vector-4"
          data-name="Vector"
          d="M3.683,1.167H.583A.58.58,0,0,1,0,.583.58.58,0,0,1,.583,0h3.1a.58.58,0,0,1,.583.583A.58.58,0,0,1,3.683,1.167Z"
          transform="translate(14.067 13.675)"
        />
        <path
          id="Vector-5"
          data-name="Vector"
          d="M5.233,1.167H.583A.58.58,0,0,1,0,.583.58.58,0,0,1,.583,0h4.65a.583.583,0,0,1,0,1.167Z"
          transform="translate(1.667 13.675)"
        />
        <path
          id="Vector-6"
          data-name="Vector"
          d="M6.583,3.292A3.292,3.292,0,1,1,3.292,0,3.292,3.292,0,0,1,6.583,3.292Z"
          transform="translate(8.258 10.975)"
        />
        <path
          id="Vector-7"
          data-name="Vector"
          d="M0,0H20V20H0Z"
          transform="translate(20 20) rotate(180)"
          fill="none"
          opacity="0"
        />
      </g>
    </g>
  </SvgIcon>
);

export const BoldSendIcon = (props: SvgIconProps) => (
  <SvgIcon width="20" height="20" viewBox="0 0 20 20" {...props}>
    <g
      id="vuesax_bold_send-2"
      data-name="vuesax/bold/send-2"
      transform="translate(-300 -316)"
    >
      <g id="send-2" transform="translate(300 316)">
        <path
          id="Vector"
          d="M10.552.308,3.537,2.639c-4.716,1.577-4.716,4.148,0,5.717l2.082.691.691,2.082c1.569,4.715,4.149,4.715,5.718,0l2.338-7.007C15.408.976,13.7-.741,10.552.308ZM10.8,4.487,7.849,7.455a.581.581,0,0,1-.824,0,.586.586,0,0,1,0-.823L9.977,3.664a.582.582,0,1,1,.824.823Z"
          transform="translate(2.664 2.67)"
        />
        <path
          id="Vector-2"
          data-name="Vector"
          d="M0,0H20V20H0Z"
          transform="translate(20 20) rotate(180)"
          fill="none"
          opacity="0"
        />
      </g>
    </g>
  </SvgIcon>
);

export const ClipboardTextIcon = (props: SvgIconProps) => (
  <SvgIcon {...props} width="20" height="20" viewBox="0 0 20 20">
    <g
      id="vuesax_bold_clipboard-text"
      data-name="vuesax/bold/clipboard-text"
      transform="translate(-108 -252)"
    >
      <g id="clipboard-text" transform="translate(108 252)">
        <path
          id="Vector"
          d="M5.492,0H1.575A1.572,1.572,0,0,0,0,1.567V2.35A1.565,1.565,0,0,0,1.567,3.917H5.492A1.565,1.565,0,0,0,7.058,2.35V1.567A1.56,1.56,0,0,0,5.492,0Z"
          transform="translate(6.467 1.667)"
          fill="currentColor"
        />
        <path
          id="Vector-2"
          data-name="Vector"
          d="M11.625.615A2.415,2.415,0,0,1,9.217,3.023H5.3A2.415,2.415,0,0,1,2.892.615.622.622,0,0,0,1.975.073,3.726,3.726,0,0,0,0,3.365v7.842a3.734,3.734,0,0,0,3.725,3.725h7.067a3.734,3.734,0,0,0,3.725-3.725V3.365A3.726,3.726,0,0,0,12.542.073.622.622,0,0,0,11.625.615ZM7.575,10.723H3.925a.625.625,0,0,1,0-1.25h3.65a.625.625,0,0,1,0,1.25ZM9.758,7.39H3.925a.625.625,0,0,1,0-1.25H9.758a.625.625,0,0,1,0,1.25Z"
          transform="translate(2.742 3.402)"
          fill="currentColor"
        />
        <path
          id="Vector-3"
          data-name="Vector"
          d="M0,0H20V20H0Z"
          transform="translate(20 20) rotate(180)"
          fill="none"
          opacity="0"
        />
      </g>
    </g>
  </SvgIcon>
);

export const PingIcon = (props: SvgIconProps) => (
  <SvgIcon {...props} width="20" height="20" viewBox="0 0 20 20">
    <g id="Group_12304" data-name="Group 12304" transform="translate(-393.779 -341.779)">
      <rect id="Rectangle_7031" data-name="Rectangle 7031" width="20" height="20" transform="translate(393.779 341.779)" fill="none" />
      <path id="Icon_metro-pin" data-name="Icon metro-pin" d="M19.6,17.533l-6.614-3.818a1.7,1.7,0,1,0-1.7,2.939L17.9,20.472a1.7,1.7,0,0,0,1.7-2.939ZM14.148,13.4l5.144,2.97,1.75-4.869L17.49,9.455,14.148,13.4ZM10.356,25.912l4.921-5.977-2.2-1.273-2.716,7.25Zm12.811-17.1L18.759,6.267a1.273,1.273,0,0,0-1.273,2.2L21.9,11.017a1.273,1.273,0,1,0,1.272-2.2Z" transform="translate(387.283 335.867)" fill="currentColor" />
    </g>
  </SvgIcon>
);

export const FilledStarIcon = (props: SvgIconProps) => (
  <SvgIcon width="32" height="32" viewBox="0 0 32 32" {...props}>
    <path
      id="Vector"
      d="M18.764,2.311l2.824,5.679A3.525,3.525,0,0,0,23.85,9.681l5.107.846c3.264.544,4.025,2.92,1.682,5.3L26.654,19.83a3.49,3.49,0,0,0-.821,2.92L26.974,27.7c.9,3.907-1.182,5.437-4.606,3.383l-4.786-2.859a3.383,3.383,0,0,0-3.164,0L9.632,31.087C6.207,33.12,4.124,31.61,5.025,27.7L6.167,22.75a3.528,3.528,0,0,0-.821-2.92L1.361,15.823c-2.343-2.356-1.582-4.732,1.682-5.3L8.15,9.681a3.461,3.461,0,0,0,2.263-1.692l2.824-5.679C14.738-.77,17.222-.77,18.764,2.311Z"
    />
  </SvgIcon>
);

export const OutlineArrowCircleLeftIcon = (props: SvgIconProps) => (

  <SvgIcon width="24" height="24" viewBox="0 0 24 24" {...props}>
    <g id="arrow-circle-left" transform="translate(-428 -252)">
      <path
        id="Vector"
        d="M20,10A10,10,0,1,1,10,0,10,10,0,0,1,20,10Z"
        transform="translate(430 254)"
        fill="none"
        stroke="#333"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        id="Vector-2"
        data-name="Vector"
        d="M3.52,7.06,0,3.53,3.52,0"
        transform="translate(437.74 260.47)"
        fill="none"
        stroke="#333"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        id="Vector-3"
        data-name="Vector"
        d="M0,0H24V24H0Z"
        transform="translate(452 276) rotate(180)"
        fill="none"
        opacity="0"
      />
    </g>
  </SvgIcon>

);

export const BoldShareIcon = (props: SvgIconProps) => (
  <SvgIcon width="20" height="20" viewBox="0 0 20 20" {...props}>
    <svg xmlns="http://www.w3.org/2000/svg">
      <g
        id="vuesax_bold_share"
        data-name="vuesax/bold/share"
        transform="translate(-364 -316)"
      >
        <g id="share" transform="translate(364 316)">
          <path
            id="Vector"
            d="M3.559,6.176a.6.6,0,0,1-.6-.542A6.345,6.345,0,0,0,.259,1.1.6.6,0,1,1,.951.109a7.6,7.6,0,0,1,3.217,5.4.608.608,0,0,1-.542.667Z"
            transform="translate(13.407 4.432)"
          />
          <path
            id="Vector-2"
            data-name="Vector"
            d="M.6,6.185H.545A.608.608,0,0,1,0,5.518,7.569,7.569,0,0,1,3.17.11a.61.61,0,0,1,.842.142.609.609,0,0,1-.142.842A6.36,6.36,0,0,0,1.211,5.635.613.613,0,0,1,.6,6.185Z"
            transform="translate(2.514 4.465)"
          />
          <path
            id="Vector-3"
            data-name="Vector"
            d="M7.015,1.21a7.506,7.506,0,0,1-3.275.742A7.437,7.437,0,0,1,.332,1.143.6.6,0,0,1,.065.335.606.606,0,0,1,.874.06a6.223,6.223,0,0,0,1.65.558A6.368,6.368,0,0,0,4.84.643,6.293,6.293,0,0,0,6.482.118.6.6,0,0,1,7.29.4.592.592,0,0,1,7.015,1.21Z"
            transform="translate(6.31 16.373)"
          />
          <path
            id="Vector-4"
            data-name="Vector"
            d="M2.35,0A2.35,2.35,0,1,0,4.7,2.35,2.353,2.353,0,0,0,2.35,0Z"
            transform="translate(7.692 1.675)"
          />
          <path
            id="Vector-5"
            data-name="Vector"
            d="M2.35,0A2.35,2.35,0,1,0,4.7,2.35,2.353,2.353,0,0,0,2.35,0Z"
            transform="translate(1.858 11.558)"
          />
          <path
            id="Vector-6"
            data-name="Vector"
            d="M2.35,0A2.35,2.35,0,1,0,4.7,2.35,2.353,2.353,0,0,0,2.35,0Z"
            transform="translate(13.442 11.558)"
          />
          <path
            id="Vector-7"
            data-name="Vector"
            d="M0,0H20V20H0Z"
            transform="translate(20 20) rotate(180)"
            fill="none"
            opacity="0"
          />
        </g>
      </g>
    </svg>
  </SvgIcon>
);

export const TwitterIcon = (props: SvgIconProps) => (
  <SvgIcon {...props}>
    <path
      id="twitter"
      d="M34.785,9.28a.76.76,0,0,0-.866-.163l-.125.057-.318.146a6.709,6.709,0,0,0,.726-1.57.761.761,0,0,0-1.123-.877,11.264,11.264,0,0,1-2.568,1.173,7.233,7.233,0,0,0-12.274,5.192v.381l-.761-.061c-7.408-.876-9.517-5.859-9.6-6.074A1.144,1.144,0,0,0,6,7.1a6.074,6.074,0,0,0-1.477,4.237A6.85,6.85,0,0,0,6.478,16a6.928,6.928,0,0,1-.821-.574,1.143,1.143,0,0,0-1.891.964A8,8,0,0,0,7.628,21.9l-.642.117a1.143,1.143,0,0,0-.709,1.81,10.44,10.44,0,0,0,4.8,3.154,21.979,21.979,0,0,1-6.932,1.112,1.143,1.143,0,0,0-.86,1.895c.123.141,3.1,3.438,10.765,3.438,12.733,0,18.666-11.821,18.666-19.809v-.381c0-.113-.012-.223-.017-.334a11.677,11.677,0,0,0,2.222-2.753A.762.762,0,0,0,34.785,9.28Z"
      transform="translate(-2.999 -6)"
    />
  </SvgIcon>
);

export const LinkedInIcon = (props: SvgIconProps) => (
  <SvgIcon width="20" height="17" viewBox="0 0 20 17" {...props}>
    <g
      id="_77dac496b3224fc"
      data-name="77dac496b3224fc"
      transform="translate(0.001 0)"
    >
      <path
        id="Path_2525"
        data-name="Path 2525"
        d="M1163.339,272.593a.313.313,0,0,0,.316-.331c0-.234-.142-.346-.433-.346h-.47v1.228h.177v-.535h.217l.005.007.337.529h.189l-.362-.547Zm-.2-.123h-.2v-.415h.26c.134,0,.287.022.287.2,0,.2-.155.218-.343.218"
        transform="translate(-1144.323 -256.672)"
        fill="#0a66c2"
      />
      <path
        id="Path_2520"
        data-name="Path 2520"
        d="M918.183,71.738h-2.506V67.821c0-.934-.017-2.136-1.3-2.136-1.3,0-1.5,1.018-1.5,2.068v3.985h-2.506V63.683h2.405v1.1h.034a2.637,2.637,0,0,1,2.373-1.3c2.539,0,3.008,1.668,3.008,3.837Zm-10.646-9.156a1.452,1.452,0,1,1,1.454-1.452,1.453,1.453,0,0,1-1.454,1.452m1.253,9.156h-2.508V63.683h2.508Zm10.642-14.382h-14.41a1.233,1.233,0,0,0-1.248,1.217V73.017a1.234,1.234,0,0,0,1.248,1.218h14.41a1.236,1.236,0,0,0,1.253-1.218V58.571a1.236,1.236,0,0,0-1.253-1.217"
        transform="translate(-903.776 -57.355)"
        fill="#0a66c2"
      />
      <path
        id="Path_2526"
        data-name="Path 2526"
        d="M1153.3,264.22a1.153,1.153,0,1,0,.022,0h-.022m0,2.17a1.009,1.009,0,1,1,.994-1.026v.017a.988.988,0,0,1-.968,1.009h-.026"
        transform="translate(-1134.462 -249.523)"
        fill="#0a66c2"
      />
    </g>
  </SvgIcon>
);

export const WhatsAppIcon = (props: SvgIconProps) => (
  <SvgIcon width="20" height="20" viewBox="0 0 20 20" {...props}>
    <g id="icons8-whatsapp" transform="translate(-3.868 -4)">
      <path
        id="Path_17644"
        data-name="Path 17644"
        d="M4.868,24.007l1.343-4.88A9.452,9.452,0,0,1,21.1,7.762a9.342,9.342,0,0,1,2.769,6.663,9.454,9.454,0,0,1-9.461,9.418h0A9.483,9.483,0,0,1,9.884,22.7Z"
        transform="translate(-0.502 -0.504)"
        fill="#fff"
        fillRule="evenodd"
      />
      <path
        id="Path_17645"
        data-name="Path 17645"
        d="M4.617,24a.248.248,0,0,1-.24-.313l1.315-4.782A9.7,9.7,0,0,1,21.028,7.335a9.588,9.588,0,0,1,2.842,6.839A9.719,9.719,0,0,1,9.6,22.71L4.681,23.995A.229.229,0,0,1,4.617,24Z"
        transform="translate(-0.251 -0.252)"
        fill="#fff"
        fillRule="evenodd"
      />
      <path
        id="Path_17646"
        data-name="Path 17646"
        d="M13.907,4.5a9.422,9.422,0,1,1,0,18.844h0a9.483,9.483,0,0,1-4.521-1.147L4.366,23.5l1.343-4.88A9.416,9.416,0,0,1,13.907,4.5m0,18.844h0m0,0h0m0-19.34h0A9.913,9.913,0,0,0,5.173,18.689L3.885,23.373a.494.494,0,0,0,.127.48.5.5,0,0,0,.481.131l4.827-1.26a9.969,9.969,0,0,0,14.547-8.8A9.939,9.939,0,0,0,13.907,4Z"
        fill="#cfd8dc"
        fillRule="evenodd"
      />
      <path
        id="Path_17647"
        data-name="Path 17647"
        d="M21.659,10.5A7.85,7.85,0,0,0,9.434,20.2l.187.3-.795,2.889,2.977-.777.288.17a7.874,7.874,0,0,0,4,1.091h0a7.857,7.857,0,0,0,7.864-7.829A7.764,7.764,0,0,0,21.659,10.5Z"
        transform="translate(-2.189 -2.119)"
        fill="#40c351"
        fillRule="evenodd"
      />
      <path
        id="Path_17648"
        data-name="Path 17648"
        d="M16.808,15.626c-.177-.392-.363-.4-.532-.407-.138-.006-.3-.005-.453-.005a.871.871,0,0,0-.63.295,2.634,2.634,0,0,0-.828,1.963,4.568,4.568,0,0,0,.965,2.434,9.69,9.69,0,0,0,4.039,3.553c2,.784,2.4.628,2.837.589a2.386,2.386,0,0,0,1.6-1.119,1.964,1.964,0,0,0,.138-1.119c-.059-.1-.217-.157-.453-.275s-1.4-.687-1.616-.766-.374-.118-.532.118-.61.766-.749.922-.276.177-.512.059a6.477,6.477,0,0,1-1.9-1.168,7.1,7.1,0,0,1-1.315-1.63c-.138-.235-.015-.363.1-.48s.236-.275.355-.412a1.609,1.609,0,0,0,.236-.393.431.431,0,0,0-.02-.412C17.478,17.256,17.019,16.092,16.808,15.626Z"
        transform="translate(-5.266 -5.649)"
        fill="#fff"
        fillRule="evenodd"
      />
    </g>
  </SvgIcon>
);

export const FacebookRoundIcon = (props: SvgIconProps) => (
  <SvgIcon {...props}>
    <g id="g10" transform="translate(0 1365.33)">
      <g id="g12" transform="translate(0 -1365.33)">
        <path
          id="path14"
          d="M20-1355.333a10,10,0,0,0-10-10,10,10,0,0,0-10,10,10,10,0,0,0,8.438,9.875v-6.986H5.9v-2.89H8.438v-2.2a3.528,3.528,0,0,1,3.777-3.89,15.387,15.387,0,0,1,2.238.2v2.46H13.192a1.445,1.445,0,0,0-1.63,1.561v1.875h2.773l-.443,2.89h-2.33v6.986A10,10,0,0,0,20-1355.333"
          transform="translate(0 1365.33)"
          fill="#1877f2"
        />
        <path
          id="path16"
          d="M411.069-1089.22l.466-3.039H408.62v-1.972a1.519,1.519,0,0,1,1.713-1.641h1.326v-2.587a16.173,16.173,0,0,0-2.353-.205c-2.4,0-3.97,1.455-3.97,4.09v2.316h-2.669v3.039h2.669v7.346a10.589,10.589,0,0,0,1.642.128,10.589,10.589,0,0,0,1.642-.128v-7.346h2.449"
          transform="translate(-396.993 1101.747)"
          fill="#fff"
        />
      </g>
    </g>
  </SvgIcon>
);

export const BoldSmsIcon = (props: SvgIconProps) => (
  <SvgIcon width="20" height="20" viewBox="0 0 20 20" {...props}>
    <g
      id="vuesax_bold_sms"
      data-name="vuesax/bold/sms"
      transform="translate(-556 -252)"
    >
      <g id="sms" transform="translate(556 252)">
        <path id="Vector" d="M0,0H20V20H0Z" fill="none" opacity="0" />
        <path
          id="Vector-2"
          data-name="Vector"
          d="M12.5,0H4.167C1.667,0,0,1.25,0,4.167V10c0,2.917,1.667,4.167,4.167,4.167H12.5c2.5,0,4.167-1.25,4.167-4.167V4.167C16.667,1.25,15,0,12.5,0Zm.392,5.075L10.283,7.158a3.217,3.217,0,0,1-3.9,0L3.775,5.075a.641.641,0,0,1-.1-.883.623.623,0,0,1,.875-.1L7.158,6.175a1.988,1.988,0,0,0,2.342,0l2.608-2.083a.615.615,0,0,1,.875.1A.632.632,0,0,1,12.892,5.075Z"
          transform="translate(1.667 2.917)"
          fill="#333"
        />
      </g>
    </g>
  </SvgIcon>
);

export const BoldTickCirlcIcon = (props: SvgIconProps) => (
  <SvgIcon viewBox="0 0 24 24" {...props}>
    <path d="M12 2C6.49 2 2 6.49 2 12C2 17.51 6.49 22 12 22C17.51 22 22 17.51 22 12C22 6.49 17.51 2 12 2ZM16.78 9.7L11.11 15.37C10.97 15.51 10.78 15.59 10.58 15.59C10.38 15.59 10.19 15.51 10.05 15.37L7.22 12.54C6.93 12.25 6.93 11.77 7.22 11.48C7.51 11.19 7.99 11.19 8.28 11.48L10.58 13.78L15.72 8.64C16.01 8.35 16.49 8.35 16.78 8.64C17.07 8.93 17.07 9.4 16.78 9.7Z" />
  </SvgIcon>
);

export const BoldVideoIcon: React.FC<SvgIconProps> = (props) => (
  <SvgIcon width="20" height="20" viewBox="0 0 20 20" {...props}>
    <g
      id="vuesax_bold_video"
      data-name="vuesax/bold/video"
      transform="translate(-108 -252)"
    >
      <g id="video" transform="translate(108 252)">
        <path
          id="Vector"
          d="M16.167,2.433a1.874,1.874,0,0,0-2.033.308l-1.225.867C12.817,1.017,11.692,0,8.958,0h-5C1.108,0,0,1.108,0,3.958v6.667a3.679,3.679,0,0,0,3.958,3.958h5c2.733,0,3.858-1.017,3.95-3.608l1.225.867a2.293,2.293,0,0,0,1.325.483,1.516,1.516,0,0,0,.708-.175,1.881,1.881,0,0,0,.917-1.842V4.275A1.881,1.881,0,0,0,16.167,2.433ZM7.708,6.775A1.567,1.567,0,1,1,9.275,5.208,1.57,1.57,0,0,1,7.708,6.775Z"
          transform="translate(1.458 2.708)"
        />
        <path
          id="Vector-2"
          data-name="Vector"
          d="M0,0H20V20H0Z"
          fill="none"
          opacity="0"
        />
      </g>
    </g>
  </SvgIcon>
);
